import React, { useState, useEffect } from 'react';
import { 
  User, BookOpen, CheckCircle, LogOut, ChevronRight, AlertCircle, 
  Check, Star, Loader2, Users, BarChart3, Search, 
  ChevronLeft, AlertTriangle, FileText, Plus, Trash2, FolderOpen, 
  GraduationCap, X, RefreshCw, Settings, UploadCloud, Edit,
  ChevronDown, ChevronUp, MessageSquare
} from 'lucide-react';
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, 
  ResponsiveContainer, Cell, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, LabelList
} from 'recharts';
import './styles/institucional.css';

export default function App() {
  const [view, setView] = useState('login'); 
  const [role, setRole] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });
  const [adminTab, setAdminTab] = useState('stats');
  const [dashboardCareerFilter, setDashboardCareerFilter] = useState('TODAS');
  const [dashboardAcademyFilter, setDashboardAcademyFilter] = useState('TODAS');

  const [usernameInput, setUsernameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');

  const API_URL = 'http://127.0.0.1:5000/api';

  const [academiesList, setAcademiesList] = useState([]);
  const [careersList, setCareersList] = useState([]);
  const [systemUsersList, setSystemUsersList] = useState([]);
  const [auditLogList, setAuditLogList] = useState([]);
  const [acusesList, setAcusesList] = useState([]);
  const [studentAcuse, setStudentAcuse] = useState(null);
  const [validacionAcuse, setValidacionAcuse] = useState({ numero_control: '', folio: '', codigo_verificacion: '' });
  const [resultadoValidacion, setResultadoValidacion] = useState(null);
  const [systemConfig, setSystemConfig] = useState({ periodo_activo: 'ENERO - JUNIO 2026', evaluacion_abierta: 1 });
  const [executiveDashboard, setExecutiveDashboard] = useState([]);
  const [student, setStudent] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [studentAnswers, setStudentAnswers] = useState({});
  const [studentCriteria, setStudentCriteria] = useState([]);
  
  // NUEVOS ESTADOS PARA ACORDEÓN Y COMENTARIOS
  const [expandedCategory, setExpandedCategory] = useState('');
  const [studentComments, setStudentComments] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [adminKpis, setAdminKpis] = useState({ total_evaluations: 0, expected_evaluations: 0, average_score: 0, teachers_evaluated: 0, teachers_at_risk: 0 });
  const [criteriaAverages, setCriteriaAverages] = useState([]);
  const [careerParticipation, setCareerParticipation] = useState([]);
  const [teachersList, setTeachersList] = useState([]);
  const [studentsList, setStudentsList] = useState([]);
  const [subjectsList, setSubjectsList] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [inscripcionesList, setInscripcionesList] = useState([]);
  const [teacherDetailData, setTeacherDetailData] = useState(null);

  const [showAddModal, setShowAddModal] = useState(null); 
  const [editModal, setEditModal] = useState({ show: false, type: null, data: null });
  const [newAcademyName, setNewAcademyName] = useState('');
  const [newCareerName, setNewCareerName] = useState('');
  const [newSystemUser, setNewSystemUser] = useState({ nombre: '', usuario: '', password: '', rol: 'jefe_division', carrera_asignada: 'Todas', activo: 1 });
  const [deleteConfirmation, setDeleteConfirmation] = useState({ show: false, type: null, id: null });
  const [viewStudentsModal, setViewStudentsModal] = useState(null);
  const [formTeacherName, setFormTeacherName] = useState('');
  const [formTeacherEmpId, setFormTeacherEmpId] = useState('');
  const [formTeacherDept, setFormTeacherDept] = useState('');
  const [formStudentName, setFormStudentName] = useState('');
  const [formStudentCtrl, setFormStudentCtrl] = useState('');
  const [formStudentCareer, setFormStudentCareer] = useState('');
  const [formStudentSemester, setFormStudentSemester] = useState(8);
  const [formStudentNip, setFormStudentNip] = useState('');
  const [formSubjName, setFormSubjName] = useState('');
  const [formSubjCode, setFormSubjCode] = useState('');
  const [formSubjCareer, setFormSubjCareer] = useState('');
  const [formSubjTeacher, setFormSubjTeacher] = useState('');
  const [formGroupSubj, setFormGroupSubj] = useState('');
  const [formGroupTeacher, setFormGroupTeacher] = useState('');
  const [formGroupCareer, setFormGroupCareer] = useState('');
  const [formGroupCode, setFormGroupCode] = useState('');
  const [formGroupPeriod, setFormGroupPeriod] = useState('Ene-Jun 2026');
  const [formGroupSelectedSubjects, setFormGroupSelectedSubjects] = useState([]);
  const [formGroupTeacherBySubject, setFormGroupTeacherBySubject] = useState({});
  const [formSelectedStudents, setFormSelectedStudents] = useState([]);
  const [expandedSubjectCareers, setExpandedSubjectCareers] = useState({});
  const toggleSubjectCareer = (carrera) => {
    setExpandedSubjectCareers(prev => ({ ...prev, [carrera]: !prev[carrera] }));
  };
  
  const brandColors = {
    guinda: '#9F2241', guindaHover: '#821C35', dorado: '#BC955C', grayText: '#6B7280', greenAccent: '#10B981', redAccent: '#EF4444'
  };

  const currentRole = currentUser?.rol || 'administrador';
  const isAdmin = currentRole === 'administrador';
  const isGestor = currentRole === 'gestor';
  const isJefeDivision = currentRole === 'jefe_division';
  const isDocente = currentRole === 'docente';
  const isControlEscolar = currentRole === 'control_escolar';
  const canEditCatalogs = isAdmin || isGestor || isJefeDivision;
  const canDeleteRecords = isAdmin;
  const authHeaders = {
    'Content-Type': 'application/json',
    'X-User-Role': currentRole,
    'X-User-Name': currentUser?.usuario || currentUser?.nombre || 'sistema'
  };

  const triggerNotification = (message, type = 'info') => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: 'info' }), 4000);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/admin/carga-masiva`, { method: 'POST', body: formData });
      if (response.ok) {
        triggerNotification("Datos cargados correctamente", "success");
        await fetchAdminDashboardData();
      } else {
        const errData = await response.json();
        triggerNotification(errData.mensaje || "Error al procesar archivo", "error");
      }
    } catch (error) {
      triggerNotification("Error de conexión con el servidor", "error");
    } finally {
      setLoading(false);
      event.target.value = null; 
    }
  };

  useEffect(() => {
    const fetchCriterios = async () => {
      try {
        const res = await fetch(`${API_URL}/criterios`);
        const data = await res.json();
        if (res.ok) setStudentCriteria(data.datos);
      } catch (err) {
        console.warn("Usando preguntas simuladas (No hay conexión API)");
      }
    };
    fetchCriterios();
  }, []);

  useEffect(() => {
    const restoreSession = async () => {
      const savedSession = localStorage.getItem('itsa_session');
      if (savedSession) {
        const parsed = JSON.parse(savedSession);
        if (parsed.role === 'admin') {
          setRole('admin');
          setCurrentUser(parsed.usuario || { nombre: 'Administrador General', usuario: 'admin', rol: 'administrador', rol_label: 'Administrador' });
          await fetchAdminDashboardData();
          if ((parsed.usuario || {}).rol === 'control_escolar') setAdminTab('validar_acuse');
          setView('admin_dashboard');
        } else if (parsed.role === 'student') {
          setRole('student');
          setStudent(parsed.student);
          const matRes = await fetch(`${API_URL}/materias/${parsed.student.id_alumno}`);
          if(matRes.ok) setSubjects((await matRes.json()).datos);
          fetchStudentAcuse(parsed.student.id_alumno);
          setView('student_dashboard');
        }
      }
    };
    restoreSession();
  }, []);

  const fetchAdminDashboardData = async () => {
    try {
      const [resKpis, resCriterios, resDocentes, resParticipacionCarreras] = await Promise.all([
        fetch(`${API_URL}/admin/kpis`),
        fetch(`${API_URL}/admin/criterios-promedio`),
        fetch(`${API_URL}/admin/docentes`),
        fetch(`${API_URL}/admin/participacion-carreras`)
      ]);

      if (resKpis.ok && resCriterios.ok && resDocentes.ok) {
        setAdminKpis((await resKpis.json()).kpis);
        setCriteriaAverages((await resCriterios.json()).datos);
        setTeachersList((await resDocentes.json()).datos);

        if (resParticipacionCarreras.ok) {
          setCareerParticipation((await resParticipacionCarreras.json()).datos);
        }

        await fetchCatalogosSecundarios();
        return true;
      }
    } catch (err) {}
    return false;
  };

  const fetchCatalogosSecundarios = async () => {
    try {
      const resAcad = await fetch(`${API_URL}/admin/academies`).catch(() => null);
      if (resAcad?.ok) setAcademiesList((await resAcad.json()).datos);
      const resCar = await fetch(`${API_URL}/admin/careers`).catch(() => null);
      if (resCar?.ok) setCareersList((await resCar.json()).datos);
      const resAlum = await fetch(`${API_URL}/admin/alumnos`).catch(() => null);
      if (resAlum?.ok) setStudentsList((await resAlum.json()).datos);
      const resMat = await fetch(`${API_URL}/admin/materias`).catch(() => null);
      if (resMat?.ok) setSubjectsList((await resMat.json()).datos);
      const resGrup = await fetch(`${API_URL}/admin/grupos`).catch(() => null);
      if (resGrup?.ok) setGroupsList((await resGrup.json()).datos);
      const resIns = await fetch(`${API_URL}/admin/inscripciones`).catch(() => null);
      if (resIns?.ok) setInscripcionesList((await resIns.json()).datos);
      const resUsers = await fetch(`${API_URL}/admin/usuarios`).catch(() => null);
      if (resUsers?.ok) setSystemUsersList((await resUsers.json()).datos);
      const resAudit = await fetch(`${API_URL}/admin/auditoria`).catch(() => null);
      if (resAudit?.ok) setAuditLogList((await resAudit.json()).datos);
      const resAcuses = await fetch(`${API_URL}/admin/acuses-alumnos`).catch(() => null);
      if (resAcuses?.ok) setAcusesList((await resAcuses.json()).datos || []);
      const resConfig = await fetch(`${API_URL}/admin/configuracion-sistema`).catch(() => null);
      if (resConfig?.ok) setSystemConfig((await resConfig.json()).configuracion);
      const resEjecutivo = await fetch(`${API_URL}/admin/dashboard-ejecutivo`).catch(() => null);
      if (resEjecutivo?.ok) setExecutiveDashboard((await resEjecutivo.json()).carreras || []);
    } catch (e) {}
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const usr = usernameInput.trim();
    const pwd = passwordInput.trim();

    try {
      const res = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ numero_control: usr, nip_password: pwd })
      });
      const data = await res.json();

      if (res.ok && data.status === 'success' && data.tipo_usuario === 'administrativo') {
        setRole('admin');
        setCurrentUser(data.usuario);
        localStorage.setItem('itsa_session', JSON.stringify({ role: 'admin', usuario: data.usuario }));
        await fetchAdminDashboardData();
        if (data.usuario.rol === 'control_escolar') setAdminTab('validar_acuse');
        setView('admin_dashboard');
        triggerNotification(`Sesión iniciada: ${data.usuario.rol_label || data.usuario.rol}`, 'success');
      } else if (res.ok && data.status === 'success' && data.tipo_usuario === 'alumno') {
        setStudent(data.alumno);
        setRole('student');
        setCurrentUser(null);
        localStorage.setItem('itsa_session', JSON.stringify({ role: 'student', student: data.alumno }));

        const matRes = await fetch(`${API_URL}/materias/${data.alumno.id_alumno}`);
        if(matRes.ok) setSubjects((await matRes.json()).datos);
        fetchStudentAcuse(data.alumno.id_alumno);

        setView('student_dashboard');
        triggerNotification(`Bienvenido, ${data.alumno.nombre}`, 'success');
      } else {
        setError(data.mensaje || 'Usuario o contraseña incorrectos.');
      }
    } catch (err) {
      setError("Error de autenticación. Revisa tu conexión a la API.");
    }

    setLoading(false);
  };

  const fetchStudentAcuse = async (idAlumno) => {
    if (!idAlumno) return;
    try {
      const res = await fetch(`${API_URL}/alumno/${idAlumno}/acuse`);
      if (res.ok) {
        const data = await res.json();
        setStudentAcuse(data.acuse || null);
      } else {
        setStudentAcuse(null);
      }
    } catch (err) {
      setStudentAcuse(null);
    }
  };

  const descargarAcuseAlumno = () => {
    if (!student?.id_alumno) return;
    window.open(`${API_URL}/alumno/${student.id_alumno}/acuse/pdf`, '_blank');
  };

  const descargarAcuseAdmin = (idAcuse) => {
    window.open(`${API_URL}/admin/acuses-alumnos/${idAcuse}/pdf`, '_blank');
  };

  const validarAcuseControlEscolar = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResultadoValidacion(null);
    try {
      const res = await fetch(`${API_URL}/validar-acuse`, {
        method: 'POST',
        headers: authHeaders,
        body: JSON.stringify(validacionAcuse)
      });
      const data = await res.json();
      setResultadoValidacion(data);
      if (res.ok && data.valido) triggerNotification('Acuse válido.', 'success');
      else triggerNotification(data.mensaje || 'Acuse no encontrado.', 'warning');
    } catch (err) {
      triggerNotification('Error al validar acuse.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => { 
    localStorage.removeItem('itsa_session');
    setView('login'); setRole(null); setCurrentUser(null); setStudent(null); setStudentAcuse(null); setSubjects([]); 
    setSelectedSubject(null); setSelectedTeacher(null); setUsernameInput(''); 
    setPasswordInput(''); setError(''); 
  };

  // INICIO DE EVALUACIÓN: SE RESETEAN COMENTARIOS Y SE ABRE EL PRIMER ACORDEÓN
  const startEvaluation = (subject) => { 
    setSelectedSubject(subject); 
    setStudentAnswers({}); 
    setStudentComments('');
    
    if (studentCriteria.length > 0) {
      setExpandedCategory(studentCriteria[0].cat);
    }
    
    setView('student_evaluation'); 
  };

  const handleStudentAnswer = (questionId, value) => setStudentAnswers(prev => ({ ...prev, [questionId]: value }));

  const submitEvaluation = async () => {
    if (Object.keys(studentAnswers).length < studentCriteria.length) { triggerNotification('Responde todas las preguntas de todas las secciones.', 'warning'); return; }
    setLoading(true);
    const formatoRespuestas = Object.entries(studentAnswers).map(([id_criterio, calificacion]) => ({ id_criterio: parseInt(id_criterio), calificacion }));
    try {
      const res = await fetch(`${API_URL}/evaluar`, {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ 
          id_alumno: student.id_alumno, 
          id_grupo: selectedSubject.id_grupo, 
          respuestas: formatoRespuestas,
          comentarios: studentComments // SE ENVÍAN LOS COMENTARIOS
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.acuse) setStudentAcuse(data.acuse);
        const matRes = await fetch(`${API_URL}/materias/${student.id_alumno}`);
        if(matRes.ok) setSubjects((await matRes.json()).datos);
        await fetchStudentAcuse(student.id_alumno);
        setView('student_success');
      } else throw new Error();
    } catch (err) { triggerNotification('Error al guardar evaluación.', 'error'); }
    setLoading(false);
  };

  // --- FUNCIONES DE REGISTRO Y EDICIÓN (CRUD) ---
  const processAddTeacher = async (e) => {
    e.preventDefault();
    await fetch(`${API_URL}/admin/docentes`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ numero_empleado: formTeacherEmpId, nombre_completo: formTeacherName, academia: formTeacherDept }) });
    triggerNotification('Docente registrado.', 'success'); setShowAddModal(null); await fetchAdminDashboardData();
  };
  const processAddStudent = async (e) => {
  e.preventDefault();
  
  const payload = { 
    numero_control: formStudentCtrl, 
    nombre_completo: formStudentName, 
    carrera: formStudentCareer, 
    semestre: parseInt(formStudentSemester), 
    nip_password: formStudentCtrl, // <--- NIP igual a matrícula
    grupos_inscritos: formSelectedStudents // <--- Enviamos la lista de grupos seleccionados
  };

  await fetch(`${API_URL}/admin/alumnos`, { 
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' }, 
    body: JSON.stringify(payload) 
  });
  
  triggerNotification('Alumno registrado e inscrito.', 'success'); 
  setShowAddModal(null); 
  setFormSelectedStudents([]); // Limpiar selección
  await fetchAdminDashboardData();
};
  const processAddSubject = async (e) => {
    e.preventDefault();
    await fetch(`${API_URL}/admin/materias`, { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ 
        clave_materia: formSubjCode, 
        nombre_materia: formSubjName, 
        carrera: formSubjCareer,
        id_docente: formSubjTeacher // <-- Enviamos al docente seleccionado
      }) 
    });
    triggerNotification('Materia y docente agregados.', 'success'); 
    setShowAddModal(null); 
    setFormSubjTeacher(''); // Limpiamos el selector para la próxima vez
    await fetchAdminDashboardData();
  };
  const processAddGroup = async (e) => {
    e.preventDefault();

    const claveGrupo = formGroupCode.trim().toUpperCase();
    const semestreDetectado = getSemesterFromGroupCode(claveGrupo);

    if (!formGroupCareer) {
      triggerNotification('Seleccione una carrera.', 'warning');
      return;
    }

    if (!semestreDetectado) {
      triggerNotification('La clave del grupo debe iniciar con el semestre. Ejemplo: 209C, 409C, 609C, 809C o 1009C.', 'warning');
      return;
    }

    if (formGroupSelectedSubjects.length === 0) {
      triggerNotification('Seleccione al menos una materia del semestre detectado.', 'warning');
      return;
    }

    const materiasSinDocente = formGroupSelectedSubjects.filter(
      idMateria => !formGroupTeacherBySubject[idMateria]
    );

    if (materiasSinDocente.length > 0) {
      triggerNotification('Seleccione docente para todas las materias seleccionadas.', 'warning');
      return;
    }

    try {
      setLoading(true);

      for (const idMateria of formGroupSelectedSubjects) {
        const res = await fetch(`${API_URL}/admin/grupos`, {
          method: 'POST',
          headers: authHeaders,
          body: JSON.stringify({
            id_materia: parseInt(idMateria, 10),
            id_docente: parseInt(formGroupTeacherBySubject[idMateria], 10),
            clave_grupo: claveGrupo,
            periodo: formGroupPeriod,
            alumnos_inscritos: formSelectedStudents
          })
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.mensaje || data.error || 'No se pudo crear una de las materias del grupo.');
        }
      }

      triggerNotification('Grupo creado con materias y alumnos matriculados.', 'success');
      setShowAddModal(null);
      setFormGroupCareer('');
      setFormGroupCode('');
      setFormGroupSelectedSubjects([]);
      setFormGroupTeacherBySubject({});
      setFormSelectedStudents([]);
      await fetchAdminDashboardData();
    } catch (err) {
      triggerNotification(err.message || 'Error al crear el grupo.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const processEditEntity = async (e) => {
    e.preventDefault();
    const { type, data } = editModal;
    let url = '';
    let payload = {};

    if (type === 'docente') {
      url = `${API_URL}/admin/docente/${data.id_docente}`;
      payload = { numero_empleado: data.employee_number, nombre_completo: data.name, academia: data.department };
    } else if (type === 'alumno') {
      url = `${API_URL}/admin/alumno/${data.id_alumno}`;
      payload = { 
        numero_control: data.numero_control, 
        nombre_completo: data.nombre_completo, 
        carrera: data.carrera, 
        semestre: data.semestre,
        grupos_inscritos: formSelectedStudents // <-- Enviamos las nuevas materias
      };
    } else if (type === 'materia') {
      url = `${API_URL}/admin/materia/${data.id_materia}`;
      payload = { 
        clave_materia: data.clave_materia, 
        nombre_materia: data.nombre_materia, 
        carrera: data.carrera,
        id_docente: data.id_docente,
        id_grupo: data.id_grupo
      };
    } else if (type === 'usuario_sistema') {
      url = `${API_URL}/admin/usuario/${data.id_usuario}`;
      payload = {
        nombre: data.nombre,
        usuario: data.usuario,
        rol: data.rol,
        carrera_asignada: data.carrera_asignada || 'Todas',
        activo: Number(data.activo ?? 1)
      };

      if ((data.password || '').trim()) {
        payload.password = data.password.trim();
      }
    }

    try {
      const res = await fetch(url, { method: 'PUT', headers: authHeaders, body: JSON.stringify(payload) });
      if (res.ok) {
        triggerNotification('Registro actualizado correctamente.', 'success');
        setEditModal({ show: false, type: null, data: null });
        setFormSelectedStudents([]); // <-- Limpiamos el formulario al terminar
        await fetchAdminDashboardData();
        await fetchCatalogosSecundarios();
      } else throw new Error();
    } catch (err) {
      triggerNotification('Error al actualizar.', 'error');
    }
  };

  const processDeleteEntity = async (type, id) => {
    if (!canDeleteRecords) {
      triggerNotification('Tu perfil no permite eliminar registros. Puedes editar, pero no borrar información.', 'warning');
      return;
    }

    const res = await fetch(`${API_URL}/admin/${type}/${id}`, {
      method: 'DELETE',
      headers: authHeaders
    });

    if (res.ok) {
      triggerNotification('Registro eliminado.', 'success');
      await fetchAdminDashboardData();
    } else {
      triggerNotification('No fue posible eliminar el registro.', 'error');
    }
  };

  const handleAddAcademy = async (e) => {
    e.preventDefault();
    await fetch(`${API_URL}/admin/academies`, { method: 'POST', headers: authHeaders, body: JSON.stringify({ nombre: newAcademyName.trim() }) });
    triggerNotification('Academia añadida.', 'success'); setNewAcademyName(''); await fetchCatalogosSecundarios();
  };
  const handleAddCareer = async (e) => {
    e.preventDefault();
    await fetch(`${API_URL}/admin/careers`, { method: 'POST', headers: authHeaders, body: JSON.stringify({ nombre: newCareerName.trim() }) });
    triggerNotification('Carrera añadida.', 'success'); setNewCareerName(''); await fetchCatalogosSecundarios();
  };
  const handleDeleteAcademy = async (academy) => { await fetch(`${API_URL}/admin/academies/${encodeURIComponent(academy)}`, { method: 'DELETE' }); await fetchCatalogosSecundarios(); triggerNotification('Academia eliminada.', 'success'); };
  const handleDeleteCareer = async (career) => { await fetch(`${API_URL}/admin/careers/${encodeURIComponent(career)}`, { method: 'DELETE', headers: authHeaders }); await fetchCatalogosSecundarios(); triggerNotification('Carrera eliminada.', 'success'); };

  const processAddSystemUser = async (e) => {
    e.preventDefault();

    if (!isAdmin) {
      triggerNotification('Solo el administrador puede crear usuarios.', 'warning');
      return;
    }

    const res = await fetch(`${API_URL}/admin/usuarios`, {
      method: 'POST',
      headers: authHeaders,
      body: JSON.stringify(newSystemUser)
    });

    if (res.ok) {
      triggerNotification('Usuario creado correctamente.', 'success');
      setNewSystemUser({ nombre: '', usuario: '', password: '', rol: 'jefe_division', carrera_asignada: 'Todas', activo: 1 });
      await fetchCatalogosSecundarios();
    } else {
      const err = await res.json().catch(() => ({}));
      triggerNotification(err.mensaje || 'No fue posible crear el usuario.', 'error');
    }
  };

  const abrirEdicionUsuario = (usuario) => {
    if (!isAdmin) {
      triggerNotification('Solo el administrador puede editar usuarios.', 'warning');
      return;
    }

    setEditModal({
      show: true,
      type: 'usuario_sistema',
      data: {
        ...usuario,
        password: ''
      }
    });
  };

  const cambiarEstadoUsuario = async (usuario, nuevoActivo) => {
    if (!isAdmin) {
      triggerNotification('Solo el administrador puede modificar usuarios.', 'warning');
      return;
    }

    if (usuario.usuario === currentUser?.usuario && Number(nuevoActivo) === 0) {
      triggerNotification('No puedes desactivar tu propio usuario mientras estás en sesión.', 'warning');
      return;
    }

    try {
      const payload = {
        nombre: usuario.nombre,
        usuario: usuario.usuario,
        rol: usuario.rol,
        carrera_asignada: usuario.carrera_asignada || 'Todas',
        activo: nuevoActivo
      };

      const res = await fetch(`${API_URL}/admin/usuario/${usuario.id_usuario}`, {
        method: 'PUT',
        headers: authHeaders,
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        triggerNotification(nuevoActivo ? 'Usuario reactivado correctamente.' : 'Usuario desactivado correctamente.', 'success');
        await fetchCatalogosSecundarios();
      } else {
        const err = await res.json().catch(() => ({}));
        triggerNotification(err.mensaje || 'No fue posible actualizar el usuario.', 'error');
      }
    } catch (err) {
      triggerNotification('Error de conexión al actualizar usuario.', 'error');
    }
  };

  const actualizarConfiguracionSistema = async (nuevaConfig) => {
    if (!(isAdmin || isGestor)) {
      triggerNotification('Solo Administrador o Desarrollo Académico pueden cambiar el periodo.', 'warning');
      return;
    }

    const res = await fetch(`${API_URL}/admin/configuracion-sistema`, {
      method: 'PUT',
      headers: authHeaders,
      body: JSON.stringify(nuevaConfig)
    });

    if (res.ok) {
      const data = await res.json();
      setSystemConfig(data.configuracion);
      triggerNotification('Configuración del periodo actualizada.', 'success');
      await fetchCatalogosSecundarios();
    } else {
      const err = await res.json().catch(() => ({}));
      triggerNotification(err.mensaje || 'No se pudo actualizar la configuración.', 'error');
    }
  };

  const handleToggleSelectStudent = (id) => setFormSelectedStudents(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);

  const getSemesterFromGroupCode = (groupCode) => {
    const clave = String(groupCode || '').trim().toUpperCase();

    if (!clave) return null;

    // Formatos soportados:
    // 209C  -> semestre 2   (primer dígito)
    // 409C  -> semestre 4
    // 609C  -> semestre 6
    // 809C  -> semestre 8
    // 1009C -> semestre 10  (inicia con 10)
    // 02A   -> semestre 2   (formato corto con cero)
    // 04B   -> semestre 4
    // 06C   -> semestre 6
    // 08A   -> semestre 8
    // 10A   -> semestre 10
    if (clave.startsWith('10')) {
      return 10;
    }

    if (clave.startsWith('0') && clave.length >= 2) {
      const semestreConCero = parseInt(clave.slice(0, 2), 10);
      return Number.isNaN(semestreConCero) ? null : semestreConCero;
    }

    const primerDigito = parseInt(clave.charAt(0), 10);

    if (Number.isNaN(primerDigito)) {
      return null;
    }

    return primerDigito;
  };

  const normalizeCareerText = (value) => String(value || '').trim().toUpperCase();

  const handleToggleGroupSubject = (idMateria) => {
    setFormGroupSelectedSubjects(prev => {
      if (prev.includes(idMateria)) {
        const updatedTeachers = { ...formGroupTeacherBySubject };
        delete updatedTeachers[idMateria];
        setFormGroupTeacherBySubject(updatedTeachers);
        return prev.filter(id => id !== idMateria);
      }

      const firstTeacherId = teachersList[0]?.id_docente ? String(teachersList[0].id_docente) : '';
      setFormGroupTeacherBySubject(prevTeachers => ({
        ...prevTeachers,
        [idMateria]: prevTeachers[idMateria] || firstTeacherId
      }));
      return [...prev, idMateria];
    });
  };

  const fetchDetailedTeacherReport = async (teacher) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/docente/${teacher.id_docente}`);
      const data = await res.json();
      if (res.ok) { setTeacherDetailData(data.docente); setSelectedTeacher(teacher); setView('admin_teacher_detail'); }
    } catch (err) {}
    setLoading(false);
  };

  const imprimirDashboardPDF = () => {
    window.print();
  };

  const descargarReporteInstitucional = () => {
    window.open(`${API_URL}/admin/reporte-institucional`, '_blank');
  };

  const descargarRespaldoBD = () => {
    window.open(`${API_URL}/admin/respaldo-db`, '_blank');
  };

  const descargarExcelInstitucional = () => {
    window.open(`${API_URL}/admin/exportacion-institucional-excel`, '_blank');
  };

  const filteredTeachers = teachersList.filter(t => t.name.toLowerCase().includes(searchTerm.toLowerCase()) || t.department.toLowerCase().includes(searchTerm.toLowerCase()));
  const filteredStudents = studentsList.filter(s => s.nombre_completo.toLowerCase().includes(searchTerm.toLowerCase()) || s.numero_control.includes(searchTerm) || s.carrera.toLowerCase().includes(searchTerm.toLowerCase()));
  const filteredSubjects = subjectsList.filter(s => s.nombre_materia.toLowerCase().includes(searchTerm.toLowerCase()) || s.clave_materia.toLowerCase().includes(searchTerm.toLowerCase()) || s.carrera.toLowerCase().includes(searchTerm.toLowerCase()));
  const filteredAcuses = acusesList.filter(a =>
    (a.folio || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (a.numero_control || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (a.nombre_completo || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (a.carrera || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (a.periodo || '').toLowerCase().includes(searchTerm.toLowerCase())
  );
  const participationPercentage = adminKpis.expected_evaluations > 0 ? Number(((adminKpis.total_evaluations / adminKpis.expected_evaluations) * 100).toFixed(1)) : 0;

  const letrasAspectos = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ".split("");

  const institutionalChartData = criteriaAverages.map((item, index) => ({
    letter: letrasAspectos[index] || `${index + 1}`,
    subject: item.name,
    score: Number(item.score || 0),
    percentage: Number(((Number(item.score || 0) / 5) * 100).toFixed(1))
  }));

  const careerParticipationChartData = careerParticipation
    .filter((item) => dashboardCareerFilter === 'TODAS' || item.carrera === dashboardCareerFilter)
    .map((item) => ({
      carrera: item.carrera,
      total_alumnos: Number(item.total_alumnos || 0),
      alumnos_evaluaron: Number(item.alumnos_evaluaron || 0),
      pendiente: Math.max(0, Number(item.total_alumnos || 0) - Number(item.alumnos_evaluaron || 0)),
      porcentaje: Number(item.porcentaje || 0)
    }));

  const selectedCareerParticipation = dashboardCareerFilter === 'TODAS'
    ? null
    : careerParticipationChartData[0] || null;

  const MIN_EVALUACIONES_RANKING = 5;

  const dashboardTeachers = teachersList.filter((teacher) =>
    dashboardAcademyFilter === 'TODAS' || teacher.department === dashboardAcademyFilter
  );

  const teachersForRanking = dashboardTeachers
    .filter((teacher) => Number(teacher.evaluationsCount || 0) >= MIN_EVALUACIONES_RANKING)
    .filter((teacher) => Number(teacher.score || 0) > 0);

  const topTeachersRanking = [...teachersForRanking]
    .sort((a, b) => Number(b.score || 0) - Number(a.score || 0))
    .slice(0, 10);

  const lowTeachersRanking = [...teachersForRanking]
    .sort((a, b) => Number(a.score || 0) - Number(b.score || 0))
    .slice(0, 10);

  const semestreGrupoDetectado = getSemesterFromGroupCode(formGroupCode);
  const materiasFiltradasParaGrupo = subjectsList.filter((materia) => {
    const mismaCarrera = normalizeCareerText(materia.carrera) === normalizeCareerText(formGroupCareer);
    const semestreMateria = Number(materia.semestre || 0);
    return mismaCarrera && semestreGrupoDetectado && semestreMateria === semestreGrupoDetectado;
  });
  const alumnosFiltradosParaGrupo = studentsList.filter(
    alumno => normalizeCareerText(alumno.carrera) === normalizeCareerText(formGroupCareer)
  );

  return (
    <div className="min-h-screen bg-gray-100 font-sans relative animate-fadeIn">
      {notification.show && (
        <div className="fixed top-5 right-5 z-50 flex items-center p-4 rounded-lg shadow-xl text-white animate-slideIn border" style={{ backgroundColor: notification.type === 'success' ? '#059669' : notification.type === 'warning' ? '#D97706' : '#DC2626', borderColor: 'rgba(255, 255, 255, 0.2)' }}>
          <CheckCircle className="h-5 w-5 mr-3 shrink-0" />
          <span className="text-sm font-bold">{notification.message}</span>
        </div>
      )}

      {deleteConfirmation.show && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 relative animate-fadeIn border-t-8 border-red-500">
            <h3 className="text-lg font-black text-gray-900 mb-2 flex items-center gap-2"><AlertTriangle className="text-red-500 h-5 w-5" /> Confirmar Baja</h3>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">¿Estás seguro de que deseas eliminar este registro? Se romperán relaciones permanentes.</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => setDeleteConfirmation({ show: false, type: null, id: null })} className="px-4 py-2 border rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 cursor-pointer">Cancelar</button>
              <button onClick={() => { processDeleteEntity(deleteConfirmation.type, deleteConfirmation.id); setDeleteConfirmation({ show: false, type: null, id: null }); }} className="px-4 py-2 text-white rounded-lg text-sm font-bold shadow bg-red-600 hover:bg-red-700 cursor-pointer">Eliminar</button>
            </div>
          </div>
        </div>
      )}

      {view === 'login' && renderLogin()}
      {view === 'student_dashboard' && renderStudentDashboard()}
      {view === 'student_evaluation' && renderStudentEvaluation()}
      {view === 'student_success' && renderStudentSuccess()}
      {view === 'admin_dashboard' && renderAdminDashboard()}
      {view === 'admin_teacher_detail' && renderAdminTeacherDetail()}
    </div>
  );

  function renderInstitutionalHeader(sectionTitle = "Sistema Integral de Evaluación Docente") {
    return (
      <header className="institutional-header">
        <div className="institutional-gob-bar">
          <div className="institutional-container institutional-gob-content">
            <img
              src="/assets/gobierno_de_mexico.png"
              alt="Gobierno de México"
              className="institutional-gob-logo"
            />
            <span className="institutional-gob-label">Gobierno de México</span>
          </div>
        </div>

        <div className="institutional-main-bar">
          <div className="institutional-container institutional-main-content">
            <div className="institutional-left-logos">
              <img
                src="/assets/pleca_tecnm.jpg"
                alt="Tecnológico Nacional de México"
                className="institutional-tecnm-logo"
              />
            </div>

            <div className="institutional-title-block">
              <p className="institutional-kicker">Tecnológico Nacional de México</p>
              <h1>Tecnológico Superior de Acayucan</h1>
              <p className="institutional-subtitle">{sectionTitle}</p>
            </div>

            <div className="institutional-right-logos">
              <img
                src="/assets/itsa.png"
                alt="Instituto Tecnológico Superior de Acayucan"
                className="institutional-itsa-logo"
              />
            </div>
          </div>
        </div>
      </header>
    );
  }

  function renderLogin() {
    return (
      <div className="login-institucional-page">
        {renderInstitutionalHeader("Sistema Integral de Evaluación Docente")}

        <main className="login-institucional-main">
          <section className="login-institucional-card">
            <div className="login-institucional-brand">
              <p className="login-institucional-kicker">Acceso institucional</p>
              <h2>Sistema Integral de Evaluación Docente</h2>
              <p className="login-institucional-text">
                Ingresa con tu usuario institucional, matrícula o credenciales autorizadas.
              </p>
            </div>

            {error && (
              <div className="login-institucional-error">
                <AlertCircle className="h-5 w-5 shrink-0" />
                <p>{error}</p>
              </div>
            )}

            <form onSubmit={handleLogin} className="login-institucional-form">
              <div>
                <label>Usuario o matrícula</label>
                <div className="login-input-wrap">
                  <User className="login-input-icon" />
                  <input
                    type="text"
                    required
                    value={usernameInput}
                    onChange={(e) => setUsernameInput(e.target.value)}
                    placeholder="Ej. admin, desarrollo, jefatura o matrícula"
                  />
                </div>
              </div>

              <div>
                <label>Contraseña o NIP</label>
                <div className="login-input-wrap">
                  <AlertCircle className="login-input-icon" />
                  <input
                    type="password"
                    required
                    value={passwordInput}
                    onChange={(e) => setPasswordInput(e.target.value)}
                    placeholder="Contraseña institucional o NIP"
                  />
                </div>
              </div>

              <button type="submit" disabled={loading} className="login-institucional-button">
                {loading ? (
                  <Loader2 className="animate-spin h-5 w-5" />
                ) : (
                  <>
                    Ingresar al Sistema
                    <ChevronRight className="h-5 w-5" />
                  </>
                )}
              </button>
            </form>

            <div className="login-institucional-help">
              <span>Administrador</span>
              <span>Desarrollo Académico</span>
              <span>Jefaturas de División</span>
              <span>Alumnado</span>
              <span>Control Escolar</span>
            </div>
          </section>
        </main>

        <footer className="login-institucional-footer">
          <strong>Tecnológico Superior de Acayucan</strong>
          <span>Sistema Integral de Evaluación Docente</span>
        </footer>
      </div>
    );
  }

  function renderStudentDashboard() {
    const pendingCount = subjects.filter(s => !s.evaluada).length;
    const progress = subjects.length > 0 ? ((subjects.length - pendingCount) / subjects.length) * 100 : 0;

    return (
      <div className="min-h-screen bg-gray-50 pb-12 institutional-page">
        {renderInstitutionalHeader("Portal de Evaluación del Alumnado")}

        <div className="student-topbar">
          <div className="institutional-container student-topbar-content">
            <div>
              <p className="student-topbar-kicker">Portal del estudiante</p>
              <h2>Evaluación Docente</h2>
            </div>
            <button onClick={handleLogout} className="student-logout-button">
              <LogOut className="h-4 w-4 mr-2" />
              Cerrar sesión
            </button>
          </div>
        </div>

        <main className="institutional-container student-main">
          <section className="student-hero-card">
            <div className="student-hero-content">
              <div>
                <p className="student-section-kicker">Información del estudiante</p>
                <h1>{student?.nombre}</h1>
                <p className="student-muted-text">Participa en la evaluación docente del periodo activo.</p>
              </div>
              <div className="student-progress-badge">
                <span>{Math.round(progress)}%</span>
                <small>Completado</small>
              </div>
            </div>

            <div className="student-info-grid">
              <div className="student-info-item">
                <span>Matrícula</span>
                <strong>{student?.numero_control}</strong>
              </div>
              <div className="student-info-item">
                <span>Carrera</span>
                <strong>{student?.carrera}</strong>
              </div>
              <div className="student-info-item">
                <span>Semestre</span>
                <strong>{student?.semestre}° Semestre</strong>
              </div>
              <div className="student-info-item">
                <span>Materias</span>
                <strong>{subjects.length}</strong>
              </div>
            </div>
          </section>

          <section className="student-card">
            <div className="student-card-header">
              <div>
                <p className="student-section-kicker">Avance de evaluación</p>
                <h3>Progreso general</h3>
              </div>
              <span className="student-progress-label">{Math.round(progress)}%</span>
            </div>
            <div className="student-progress-track">
              <div className="student-progress-fill" style={{ width: `${progress}%` }}></div>
            </div>
            {pendingCount > 0 ? (
              <p className="student-alert student-alert-warning">
                <AlertCircle className="h-5 w-5 mr-2 shrink-0" />
                Tienes {pendingCount} evaluación(es) pendiente(s).
              </p>
            ) : (
              <p className="student-alert student-alert-success">
                <CheckCircle className="h-5 w-5 mr-2 shrink-0" />
                ¡Has completado todas tus evaluaciones!
              </p>
            )}
          </section>

          {studentAcuse && (
            <section className="student-card border-l-4" style={{ borderColor: brandColors.dorado }}>
              <div className="student-card-header">
                <div>
                  <p className="student-section-kicker">Acuse generado</p>
                  <h3>Conclusión de evaluación docente</h3>
                  <p className="student-muted-text">Folio: <strong>{studentAcuse.folio}</strong></p>
                  {studentAcuse.codigo_verificacion && (
                    <p className="student-muted-text">Código de verificación: <strong>{studentAcuse.codigo_verificacion}</strong></p>
                  )}
                </div>
                <button onClick={descargarAcuseAlumno} className="student-primary-button" style={{ width: 'auto' }}>
                  <FileText className="h-4 w-4 mr-2" /> Descargar acuse
                </button>
              </div>
            </section>
          )}

          <section>
            <div className="student-section-title">
              <div>
                <p className="student-section-kicker">Cuestionarios</p>
                <h3>Materias inscritas a evaluar</h3>
              </div>
            </div>

            <div className="student-subject-grid">
              {subjects.length === 0 ? (
                <div className="student-empty-state">
                  <Loader2 className="animate-spin h-8 w-8 mx-auto text-gray-400 mb-2" />
                  <p>No hay materias inscritas.</p>
                </div>
              ) : (
                subjects.map((subject, index) => (
                  <article key={`${subject.id_grupo}-${index}`} className={`student-subject-card ${subject.evaluada ? 'is-complete' : 'is-pending'}`}>
                    <div>
                      <div className="student-subject-header">
                        <h4>{subject.materia}</h4>
                        {subject.evaluada && (
                          <span className="student-status-pill complete">Completado</span>
                        )}
                      </div>
                      <p className="student-subject-teacher">{subject.docente}</p>
                    </div>

                    <div className="student-subject-footer">
                      {!subject.evaluada ? (
                        <button onClick={() => startEvaluation(subject)} className="student-primary-button">
                          Evaluar docente
                          <ChevronRight className="ml-2 h-4 w-4" />
                        </button>
                      ) : (
                        <button disabled className="student-disabled-button">
                          <Check className="mr-2 h-4 w-4 text-green-600" />
                          Evaluación contestada
                        </button>
                      )}
                    </div>
                  </article>
                ))
              )}
            </div>
          </section>
        </main>
      </div>
    );
  }


  function renderStudentEvaluation() {
    const groupedCriteria = studentCriteria.reduce((acc, curr) => {
      if (!acc[curr.cat]) acc[curr.cat] = [];
      acc[curr.cat].push(curr);
      return acc;
    }, {});

    const totalRespondidas = Object.keys(studentAnswers).length;
    const cuestionarioCompleto = totalRespondidas === studentCriteria.length;
    const avanceCuestionario = studentCriteria.length > 0 ? Math.round((totalRespondidas / studentCriteria.length) * 100) : 0;

    return (
      <div className="min-h-screen bg-gray-50 pb-12 institutional-page">
        {renderInstitutionalHeader("Evaluación Docente del Alumnado")}

        <div className="student-topbar sticky top-0 z-10">
          <div className="institutional-container student-topbar-content">
            <button onClick={() => setView('student_dashboard')} className="student-back-button">
              <ChevronLeft className="h-4 w-4 mr-1" />
              Volver al tablero
            </button>
            <span className={`student-answer-counter ${cuestionarioCompleto ? 'complete' : ''}`}>
              {totalRespondidas} de {studentCriteria.length} respondidas
            </span>
          </div>
        </div>

        <main className="institutional-container student-main student-evaluation-main animate-fadeIn">
          <section className="student-hero-card evaluation-hero">
            <div className="student-hero-content">
              <div>
                <p className="student-section-kicker">Cuestionario de evaluación</p>
                <h1>{selectedSubject?.materia}</h1>
                <p className="student-muted-text">
                  Docente: <strong>{selectedSubject?.docente}</strong>
                </p>
              </div>
              <div className="student-progress-badge">
                <span>{avanceCuestionario}%</span>
                <small>Avance</small>
              </div>
            </div>

            <div className="student-instructions-box">
              <strong>Instrucciones:</strong> El presente cuestionario evalúa las competencias del docente. Contesta con honestidad seleccionando de 1 (Deficiente) a 5 (Excelente). Todas las preguntas son obligatorias y tus respuestas son estrictamente anónimas.
            </div>
          </section>

          <div className="student-evaluation-sections">
            {Object.entries(groupedCriteria).map(([categoria, preguntas], idx) => {
              const isExpanded = expandedCategory === categoria;
              const answeredInCategory = preguntas.filter(p => studentAnswers[p.id]).length;
              const isComplete = answeredInCategory === preguntas.length;

              return (
                <section key={categoria} className={`student-criteria-card ${isComplete ? 'complete' : ''}`}>
                  <button
                    onClick={() => setExpandedCategory(isExpanded ? '' : categoria)}
                    className="student-criteria-header"
                  >
                    <div className="student-criteria-title">
                      <span>{idx + 1}</span>
                      <h3>{categoria}</h3>
                    </div>
                    <div className="student-criteria-meta">
                      <span>{answeredInCategory} / {preguntas.length}</span>
                      {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                    </div>
                  </button>

                  {isExpanded && (
                    <div className="student-questions-list animate-fadeIn">
                      {preguntas.map((item, pIdx) => (
                        <div key={item.id} className="student-question-item">
                          <h4>
                            <span>{pIdx + 1}.</span> {item.text}
                          </h4>
                          <div className="student-rating-grid">
                            {[
                              { val: 1, label: 'Deficiente' },
                              { val: 2, label: 'Regular' },
                              { val: 3, label: 'Bueno' },
                              { val: 4, label: 'Muy Bueno' },
                              { val: 5, label: 'Excelente' }
                            ].map(option => (
                              <label key={option.val} className={`student-rating-option ${studentAnswers[item.id] === option.val ? 'selected' : ''}`}>
                                <input
                                  type="radio"
                                  name={`criterio_${item.id}`}
                                  value={option.val}
                                  className="sr-only"
                                  onChange={() => handleStudentAnswer(item.id, option.val)}
                                  checked={studentAnswers[item.id] === option.val}
                                />
                                <div className="student-stars">
                                  {[...Array(5)].map((_, i) => (
                                    <Star key={i} className={`w-4 h-4 ${i < option.val ? 'text-yellow-500 fill-yellow-500' : 'text-gray-200'}`} />
                                  ))}
                                </div>
                                <span>{option.label}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </section>
              );
            })}

            <section className="student-comments-card">
              <div className="student-comments-header">
                <MessageSquare className="h-6 w-6" />
                <div>
                  <h3>Comentarios Generales</h3>
                  <p>Opcional y confidencial.</p>
                </div>
              </div>
              <textarea
                value={studentComments}
                onChange={(e) => setStudentComments(e.target.value)}
                placeholder="Escribe aquí cualquier comentario adicional, sugerencia o felicitación para el docente..."
              ></textarea>
            </section>
          </div>

          <div className="student-submit-panel">
            <div>
              <p className="student-section-kicker">Confirmación</p>
              <h3>{cuestionarioCompleto ? 'Cuestionario completo' : 'Faltan preguntas por contestar'}</h3>
            </div>
            <button onClick={submitEvaluation} disabled={loading || !cuestionarioCompleto} className="student-submit-button">
              {loading && <Loader2 className="animate-spin h-5 w-5 mr-2" />}
              {cuestionarioCompleto ? 'Guardar Evaluación Oficial' : 'Completa todas las preguntas'}
            </button>
          </div>
        </main>
      </div>
    );
  }


  function renderStudentSuccess() {
    return (
      <div className="min-h-screen bg-gray-50 institutional-page">
        {renderInstitutionalHeader("Evaluación Guardada")}

        <main className="student-success-page">
          <section className="student-success-card">
            <div className="student-success-icon">
              <CheckCircle className="h-12 w-12" />
            </div>
            <p className="student-section-kicker">Registro exitoso</p>
            <h2>¡Evaluación guardada!</h2>
            <p>
              Se ha completado el cuestionario de forma exitosa y anónima. Tus respuestas ayudan a mejorar la calidad educativa del Tecnológico Superior de Acayucan.
            </p>
            {studentAcuse && (
              <button onClick={descargarAcuseAlumno} className="student-primary-button success-button" style={{ marginBottom: '0.75rem' }}>
                <FileText className="mr-2 h-4 w-4" /> Descargar acuse PDF
              </button>
            )}
            <button onClick={() => setView('student_dashboard')} className="student-primary-button success-button">
              Volver a mi tablero
              <ChevronRight className="ml-2 h-4 w-4" />
            </button>
          </section>
        </main>
      </div>
    );
  }


  function renderAdminDashboard() {
    return (
      <div className="min-h-screen bg-gray-50 institutional-page">
        {renderInstitutionalHeader("Sistema Integral de Evaluación Docente")}
        <div className="flex flex-col md:flex-row institutional-layout">
          <aside className="w-full md:w-64 shrink-0 text-white flex flex-col justify-between institutional-sidebar" style={{ backgroundColor: brandColors.guinda }}>
          <div>
            <div className="p-6 border-b border-white/10 flex items-center space-x-3"><GraduationCap className="h-8 w-8 text-yellow-500" /><div><h1 className="text-lg font-black tracking-wide leading-none">ITSA CONTROL</h1><p className="text-[10px] mt-1 font-bold tracking-widest text-yellow-500 uppercase">Jefatura Escolar</p></div></div>
            <nav className="p-4 space-y-1">
              {isControlEscolar && (
                <button onClick={() => { setAdminTab('validar_acuse'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'validar_acuse' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><FileText className="h-5 w-5 mr-3" />Validar Acuse</button>
              )}
              {!isControlEscolar && <>
              <button onClick={() => { setAdminTab('stats'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'stats' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><BarChart3 className="h-5 w-5 mr-3" />Vista General</button>
              <button onClick={() => { setAdminTab('teachers'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'teachers' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><Users className="h-5 w-5 mr-3" />Docentes y Academias</button>
              <button onClick={() => { setAdminTab('students'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'students' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><User className="h-5 w-5 mr-3" />Gestión Alumnos</button>
              <button onClick={() => { setAdminTab('subjects'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'subjects' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><BookOpen className="h-5 w-5 mr-3" />Gestión Materias</button>
              <button onClick={() => { setAdminTab('groups'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'groups' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><FolderOpen className="h-5 w-5 mr-3" />Grupos e Inscripciones</button>
              <button onClick={() => { setAdminTab('acuses'); setSearchTerm(''); fetchCatalogosSecundarios(); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'acuses' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><FileText className="h-5 w-5 mr-3" />Acuses de Alumnos</button>
              <button onClick={() => { setAdminTab('settings'); setSearchTerm(''); }} className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-bold transition-all cursor-pointer ${adminTab === 'settings' ? 'bg-white/10 text-white shadow-inner' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}><Settings className="h-5 w-5 mr-3" />Configuración General</button>
              </>}
            </nav>
          </div>
          <div className="p-4 border-t border-white/10"><button onClick={handleLogout} className="w-full flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold text-white/80 hover:bg-red-950/40 hover:text-white border border-white/15 transition-all cursor-pointer"><LogOut className="h-4 w-4 mr-2" />Cerrar Sesión</button></div>
        </aside>

        <main className="flex-1 p-6 md:p-8 space-y-8 overflow-y-auto max-h-screen">
          {adminTab === 'stats' && (
            <div className="space-y-8 animate-fadeIn">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-2xl font-black text-gray-900">Análisis y Estadísticas Docentes</h2>
                  <p className="text-xs text-gray-500 mt-1">Basado en las categorías del cuestionario oficial</p>
                  <div className="mt-2 flex flex-wrap gap-2">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-black bg-slate-100 text-slate-700 border">Periodo: {systemConfig?.periodo_activo || 'ENERO - JUNIO 2026'}</span>
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-black border ${Number(systemConfig?.evaluacion_abierta) === 1 ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                      {Number(systemConfig?.evaluacion_abierta) === 1 ? 'Evaluación abierta' : 'Evaluación cerrada'}
                    </span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 justify-end">
                  <button onClick={fetchAdminDashboardData} className="flex items-center px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-all cursor-pointer"><RefreshCw className="h-3.5 w-3.5 mr-1" /> Actualizar</button>
                  <button onClick={imprimirDashboardPDF} className="flex items-center px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-all cursor-pointer"><FileText className="h-3.5 w-3.5 mr-1" /> PDF</button>
                  {(isAdmin || isGestor) && (
                    <>
                      <button onClick={descargarReporteInstitucional} className="flex items-center px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-all cursor-pointer"><FileText className="h-3.5 w-3.5 mr-1" /> Reporte general</button>
                      <button onClick={descargarExcelInstitucional} className="flex items-center px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-all cursor-pointer"><FileText className="h-3.5 w-3.5 mr-1" /> Excel institucional</button>
                    </>
                  )}
                  {isAdmin && (
                    <button onClick={descargarRespaldoBD} className="flex items-center px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-bold text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-all cursor-pointer"><FolderOpen className="h-3.5 w-3.5 mr-1" /> Respaldo BD</button>
                  )}
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-4 border border-gray-100">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-black text-gray-400 uppercase tracking-wider mb-1">Filtrar participación por carrera</label>
                    <select
                      value={dashboardCareerFilter}
                      onChange={(e) => setDashboardCareerFilter(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white font-medium"
                    >
                      <option value="TODAS">Todas las carreras</option>
                      {careerParticipation.map((item) => (
                        <option key={item.carrera} value={item.carrera}>{item.carrera}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-black text-gray-400 uppercase tracking-wider mb-1">Filtrar rankings por academia</label>
                    <select
                      value={dashboardAcademyFilter}
                      onChange={(e) => setDashboardAcademyFilter(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white font-medium"
                    >
                      <option value="TODAS">Todas las academias</option>
                      {academiesList.map((academy) => (
                        <option key={academy} value={academy}>{academy}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {selectedCareerParticipation && (
                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-4 gap-3 text-center">
                    <div className="bg-gray-50 rounded-lg p-3 border"><p className="text-[10px] font-black text-gray-400 uppercase">Carrera</p><p className="text-xs font-bold text-gray-800 mt-1">{selectedCareerParticipation.carrera}</p></div>
                    <div className="bg-gray-50 rounded-lg p-3 border"><p className="text-[10px] font-black text-gray-400 uppercase">Alumnos</p><p className="text-lg font-black text-gray-900">{selectedCareerParticipation.total_alumnos}</p></div>
                    <div className="bg-gray-50 rounded-lg p-3 border"><p className="text-[10px] font-black text-gray-400 uppercase">Evaluaron</p><p className="text-lg font-black text-green-700">{selectedCareerParticipation.alumnos_evaluaron}</p></div>
                    <div className="bg-gray-50 rounded-lg p-3 border"><p className="text-[10px] font-black text-gray-400 uppercase">Pendientes</p><p className="text-lg font-black text-orange-700">{selectedCareerParticipation.pendiente}</p></div>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-white rounded-xl shadow-sm p-6 border-l-4" style={{ borderColor: brandColors.guinda }}><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Promedio Escolar</p><h3 className="text-2xl font-black text-gray-900 mt-1">{adminKpis.average_score} / 5.00</h3><p className="text-xs text-gray-500 mt-1">Calificación ponderada</p></div>
                <div className="bg-white rounded-xl shadow-sm p-6 border-l-4" style={{ borderColor: brandColors.dorado }}><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Participación Estudiantil</p><h3 className="text-2xl font-black text-gray-900 mt-1">{participationPercentage}%</h3><p className="text-xs text-gray-500 mt-1">{adminKpis.total_evaluations} de {adminKpis.expected_evaluations} alumnos participantes</p></div>
                <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-emerald-500"><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Docentes Evaluados</p><h3 className="text-2xl font-black text-gray-900 mt-1">{adminKpis.teachers_evaluated}</h3><p className="text-xs text-gray-500 mt-1">Plantilla docente calificada</p></div>
                <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-red-500"><p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Alertas Académicas</p><h3 className="text-2xl font-black text-red-600 mt-1">{adminKpis.teachers_at_risk}</h3><p className="text-xs text-gray-500 mt-1">Promedio &lt; 3.0 con mínimo 5 evaluaciones</p></div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-white rounded-xl shadow-sm p-6">
                  <h3 className="text-lg font-bold text-gray-950 mb-6">
                    Promedio Institucional por Categoría
                  </h3>

                  <div className="h-72">
                    {criteriaAverages.length === 0 ? (
                      <div className="h-full flex items-center justify-center text-gray-400">
                        Sin datos de encuestas aún
                      </div>
                    ) : (
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                          data={institutionalChartData}
                          margin={{ top: 30, right: 20, left: 0, bottom: 10 }}
                        >
                          <CartesianGrid
                            strokeDasharray="3 3"
                            vertical={false}
                            stroke="#F3F4F6"
                          />

                          <XAxis
                            dataKey="letter"
                            tickLine={false}
                            axisLine={false}
                            tick={{
                              fill: "#6B7280",
                              fontSize: 12,
                              fontWeight: "bold",
                            }}
                          />

                          <YAxis
                            domain={[0, 100]}
                            tickLine={false}
                            axisLine={false}
                            tick={{ fill: "#6B7280", fontSize: 12 }}
                            tickFormatter={(value) => `${value}%`}
                          />

                          <RechartsTooltip
                            cursor={{ fill: "#F9FAFB" }}
                            formatter={(value) => [`${value}%`, "Porcentaje"]}
                            labelFormatter={(label) => {
                              const item = institutionalChartData.find(
                                (i) => i.letter === label
                              );
                              return item ? `${item.letter}) ${item.subject}` : label;
                            }}
                          />

                          <Bar dataKey="percentage" radius={[4, 4, 0, 0]}>
                            {institutionalChartData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={brandColors.guinda} />
                            ))}

                            <LabelList
                              dataKey="percentage"
                              position="top"
                              fill="#111827"
                              fontWeight="bold"
                              formatter={(value) => `${value}%`}
                            />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    )}
                  </div>

                  {institutionalChartData.length > 0 && (
                    <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg p-4">
                      <p className="text-xs font-bold text-gray-500 mb-3 uppercase tracking-wider">
                        Aspectos evaluados:
                      </p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                        {institutionalChartData.map((item) => (
                          <div key={item.letter} className="flex items-start text-xs">
                            <span className="font-black text-gray-900 w-7 shrink-0">
                              {item.letter})
                            </span>
                            <span className="text-gray-700 leading-tight">
                              {item.subject}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-gray-950 mb-2">Casos Críticos de Desempeño</h3>
                    <p className="text-xs text-gray-400 leading-normal mb-4">Docentes con promedio menor a 3.00 y muestra suficiente (mínimo 5 evaluaciones).</p>
                    <div className="space-y-4">
                      {dashboardTeachers.filter(t => t.status === 'risk').length === 0 ? (<p className="text-sm text-green-600 bg-green-50 p-4 rounded text-center font-bold">¡Sin alertas detectadas!</p>) : (
                        dashboardTeachers.filter(t => t.status === 'risk').map(teacher => (
                          <div key={teacher.id_docente} onClick={() => fetchDetailedTeacherReport(teacher)} className="flex justify-between items-center p-3 bg-red-50 rounded-lg border border-red-100 hover:border-red-300 transition-all cursor-pointer">
                            <div><p className="font-bold text-gray-900 text-sm">{teacher.name}</p><p className="text-xs text-gray-500 mt-0.5">{teacher.department}</p></div>
                            <span className="font-black text-red-600 bg-red-100 px-2.5 py-1 rounded text-sm">{teacher.score}</span>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-6">
                  <div>
                    <h3 className="text-lg font-bold text-gray-950">
                      Participación Estudiantil por Carrera
                    </h3>
                    <p className="text-xs text-gray-500 mt-1">
                      Porcentaje de alumnos que realizaron al menos una evaluación docente.
                    </p>
                  </div>
                </div>

                {careerParticipationChartData.length === 0 ? (
                  <div className="h-64 flex items-center justify-center text-gray-400">
                    Sin datos de participación por carrera
                  </div>
                ) : (
                  <div
                    style={{
                      height: `${Math.max(280, careerParticipationChartData.length * 52)}px`
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={careerParticipationChartData}
                        layout="vertical"
                        margin={{ top: 10, right: 70, left: 20, bottom: 10 }}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={false}
                          stroke="#F3F4F6"
                        />

                        <XAxis
                          type="number"
                          domain={[0, 100]}
                          tickLine={false}
                          axisLine={false}
                          tick={{ fill: "#6B7280", fontSize: 12 }}
                          tickFormatter={(value) => `${value}%`}
                        />

                        <YAxis
                          type="category"
                          dataKey="carrera"
                          width={240}
                          tickLine={false}
                          axisLine={false}
                          tick={{ fill: "#374151", fontSize: 11, fontWeight: "bold" }}
                        />

                        <RechartsTooltip
                          cursor={{ fill: "#F9FAFB" }}
                          formatter={(value, name, props) => [
                            `${value}% (${props.payload.alumnos_evaluaron} de ${props.payload.total_alumnos} alumnos)`,
                            "Participación"
                          ]}
                        />

                        <Bar dataKey="porcentaje" radius={[0, 4, 4, 0]}>
                          {careerParticipationChartData.map((entry, index) => (
                            <Cell key={`career-cell-${index}`} fill={brandColors.dorado} />
                          ))}

                          <LabelList
                            dataKey="porcentaje"
                            position="right"
                            fill="#111827"
                            fontWeight="bold"
                            formatter={(value) => `${value}%`}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="mb-5">
                  <h3 className="text-lg font-bold text-gray-950">Dashboard ejecutivo por carrera</h3>
                  <p className="text-xs text-gray-500 mt-1">Resumen para Dirección: alumnos, participación, docentes asignados y promedio general.</p>
                </div>
                {executiveDashboard.length === 0 ? (
                  <div className="py-10 text-center text-gray-400 text-sm">Sin datos ejecutivos disponibles</div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 text-sm">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-black text-gray-400 uppercase">Carrera</th>
                          <th className="px-4 py-3 text-center text-xs font-black text-gray-400 uppercase">Alumnos</th>
                          <th className="px-4 py-3 text-center text-xs font-black text-gray-400 uppercase">Participación</th>
                          <th className="px-4 py-3 text-center text-xs font-black text-gray-400 uppercase">Docentes</th>
                          <th className="px-4 py-3 text-center text-xs font-black text-gray-400 uppercase">Promedio</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {executiveDashboard.map((item) => (
                          <tr key={item.carrera} className="hover:bg-gray-50">
                            <td className="px-4 py-3 font-bold text-gray-900">{item.carrera}</td>
                            <td className="px-4 py-3 text-center font-semibold">{item.alumnos}</td>
                            <td className="px-4 py-3 text-center font-black text-[#9F2241]">{Number(item.participacion || 0).toFixed(1)}%</td>
                            <td className="px-4 py-3 text-center font-semibold">{item.docentes_asignados}</td>
                            <td className="px-4 py-3 text-center font-black">{Number(item.promedio || 0).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-start justify-between gap-4 mb-5">
                    <div>
                      <h3 className="text-lg font-bold text-gray-950">Top 10 docentes mejor evaluados</h3>
                      <p className="text-xs text-gray-500 mt-1">Solo se consideran docentes con mínimo {MIN_EVALUACIONES_RANKING} evaluaciones{dashboardAcademyFilter !== 'TODAS' ? ` de ${dashboardAcademyFilter}` : ''}.</p>
                    </div>
                  </div>

                  {topTeachersRanking.length === 0 ? (
                    <div className="py-10 text-center text-gray-400 text-sm">Sin datos suficientes para ranking</div>
                  ) : (
                    <div className="space-y-3">
                      {topTeachersRanking.map((teacher, index) => (
                        <div key={`top-${teacher.id_docente}`} onClick={() => fetchDetailedTeacherReport(teacher)} className="flex items-center justify-between gap-4 p-3 rounded-lg border border-green-100 bg-green-50/60 hover:bg-green-50 cursor-pointer transition-colors">
                          <div className="flex items-center min-w-0">
                            <span className="w-8 h-8 rounded-full bg-green-100 text-green-700 font-black text-sm flex items-center justify-center shrink-0 mr-3">{index + 1}</span>
                            <div className="min-w-0">
                              <p className="font-bold text-gray-900 text-sm truncate">{teacher.name}</p>
                              <p className="text-xs text-gray-500 truncate">{teacher.department} • {teacher.evaluationsCount} evaluaciones</p>
                            </div>
                          </div>
                          <span className="font-black text-green-700 bg-white border border-green-100 px-3 py-1 rounded-lg text-sm shrink-0">
                            {Number(teacher.score || 0).toFixed(2)} ★
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-start justify-between gap-4 mb-5">
                    <div>
                      <h3 className="text-lg font-bold text-gray-950">10 docentes con menor promedio</h3>
                      <p className="text-xs text-gray-500 mt-1">Listado preventivo con mínimo {MIN_EVALUACIONES_RANKING} evaluaciones{dashboardAcademyFilter !== 'TODAS' ? ` de ${dashboardAcademyFilter}` : ''}.</p>
                    </div>
                  </div>

                  {lowTeachersRanking.length === 0 ? (
                    <div className="py-10 text-center text-gray-400 text-sm">Sin datos suficientes para ranking</div>
                  ) : (
                    <div className="space-y-3">
                      {lowTeachersRanking.map((teacher, index) => (
                        <div key={`low-${teacher.id_docente}`} onClick={() => fetchDetailedTeacherReport(teacher)} className="flex items-center justify-between gap-4 p-3 rounded-lg border border-orange-100 bg-orange-50/60 hover:bg-orange-50 cursor-pointer transition-colors">
                          <div className="flex items-center min-w-0">
                            <span className="w-8 h-8 rounded-full bg-orange-100 text-orange-700 font-black text-sm flex items-center justify-center shrink-0 mr-3">{index + 1}</span>
                            <div className="min-w-0">
                              <p className="font-bold text-gray-900 text-sm truncate">{teacher.name}</p>
                              <p className="text-xs text-gray-500 truncate">{teacher.department} • {teacher.evaluationsCount} evaluaciones</p>
                            </div>
                          </div>
                          <span className="font-black text-orange-700 bg-white border border-orange-100 px-3 py-1 rounded-lg text-sm shrink-0">
                            {Number(teacher.score || 0).toFixed(2)} ★
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

            </div>
          )}

          {/* ============================================================== */}
          {/* PESTAÑA DOCENTES E ACADEMIAS (AHORA CON TARJETAS)                */}
          {/* ============================================================== */}
          {adminTab === 'teachers' && (
            <div className="space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div><h2 className="text-2xl font-black text-gray-900">Catálogo de Personal Docente</h2><p className="text-xs text-gray-500 mt-1">Registra, analiza y administra la plantilla académica</p></div>
                <button onClick={() => { if (academiesList.length === 0) { triggerNotification('Registre una academia primero.', 'warning'); return; } setFormTeacherDept(academiesList[0]); setShowAddModal('teacher'); }} className="flex items-center px-4 py-2 text-sm font-bold text-white rounded-lg shadow-md transition-all cursor-pointer" style={{ backgroundColor: brandColors.guinda }}><Plus className="h-4 w-4 mr-2" /> Agregar Docente</button>
              </div>

              <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
                <div className="p-4 border-b border-gray-100 bg-gray-50 flex items-center">
                  <Search className="h-5 w-5 text-gray-400 mr-2" />
                  <input type="text" placeholder="Buscar docente..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full bg-transparent border-none text-sm focus:outline-none" />
                </div>
                
                {/* CONTENEDOR EN REJILLA DE TARJETAS */}
                <div className="p-4 bg-gray-50/50">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filteredTeachers.length === 0 ? (
                      <div className="col-span-full text-center py-8 text-gray-500">No se encontraron docentes.</div>
                    ) : (
                      filteredTeachers.map((teacher) => (
                        <div key={teacher.id_docente} className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300 flex flex-col overflow-hidden">
                          {/* ENCABEZADO DE LA TARJETA */}
                          <div className="p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
                            <div className="flex justify-between items-start gap-2 mb-1">
                              <h4 className="font-bold text-gray-900 text-base leading-tight line-clamp-2 cursor-pointer hover:text-[#9F2241] transition-colors" onClick={() => fetchDetailedTeacherReport(teacher)}>
                                {teacher.name}
                              </h4>
                              <span className={`px-2 py-1 rounded-full text-[10px] font-black shrink-0 uppercase tracking-wider ${
                                teacher.status === 'excellent' ? 'bg-green-100 text-green-700' :
                                teacher.status === 'average' ? 'bg-blue-100 text-blue-700' :
                                teacher.status === 'risk' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'
                              }`}>
                                {teacher.score > 0 ? `${parseFloat(teacher.score).toFixed(2)} ★` : 'PND'}
                              </span>
                            </div>
                            <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">{teacher.department}</p>
                          </div>

                          {/* CUERPO DE LA TARJETA */}
                          <div className="p-5 flex-1 space-y-4">
                            <div className="flex justify-between text-xs text-gray-500 border-b border-gray-50 pb-3">
                              <span>No. Emp: <strong className="text-gray-700 font-medium">{teacher.employee_number || 'N/A'}</strong></span>
                              <span>Evals: <strong className="text-gray-700 font-medium">{teacher.evaluationsCount}</strong></span>
                            </div>

                            <div className="flex justify-end">
                              <span className={`text-[10px] font-black px-2 py-1 rounded-full uppercase tracking-wider ${
                                teacher.reliability === 'confiable' ? 'bg-green-100 text-green-700' :
                                teacher.reliability === 'preliminar' ? 'bg-yellow-100 text-yellow-700' :
                                teacher.reliability === 'muestra_insuficiente' ? 'bg-orange-100 text-orange-700' :
                                'bg-gray-100 text-gray-600'
                              }`}>
                                {teacher.reliabilityLabel || 'Sin datos'}
                              </span>
                            </div>

                            {/* LISTADO DE MATERIAS ASIGNADAS */}
                            <div>
                              <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">
                                Materias Asignadas ({(teacher.materias || []).length})
                              </span>
                              {(teacher.materias || []).length > 0 ? (
                                <div className="flex flex-wrap gap-1.5 max-h-24 overflow-y-auto pr-1">
                                  {(teacher.materias || []).map((materia, idx) => (
                                    <span key={idx} className="inline-block bg-slate-50 text-slate-700 text-[10px] font-medium px-2 py-1 rounded-md border border-slate-200/60">
                                      {materia}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-[11px] italic text-gray-400">Sin materias cargadas en este período.</p>
                              )}
                            </div>
                          </div>

                          {/* PIE DE LA TARJETA */}
                          <div className="px-5 py-3 bg-gray-50/80 border-t border-gray-100 flex justify-between items-center">
                            <button onClick={() => fetchDetailedTeacherReport(teacher)} className="text-xs font-bold text-[#9F2241] hover:text-[#821C35] cursor-pointer uppercase tracking-wider flex items-center transition-colors">
                              <BarChart3 className="h-3.5 w-3.5 mr-1" /> Analizar
                            </button>
                            <div className="flex gap-3">
                              <button onClick={() => setEditModal({ show: true, type: 'docente', data: teacher })} className="text-gray-500 hover:text-blue-600 cursor-pointer transition-colors" title="Editar">
                                <Edit className="h-4 w-4" />
                              </button>
                              <button onClick={() => setDeleteConfirmation({ show: true, type: 'docente', id: teacher.id_docente })} className="text-gray-400 hover:text-red-600 cursor-pointer transition-colors" title="Eliminar">
                                <Trash2 className="h-4 w-4" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {adminTab === 'students' && (() => {
            // 1. MAPAS DE BÚSQUEDA (Optimización de rendimiento)
            const mapGrupos = new Map(groupsList.map(g => [g.id_grupo, g]));
            const mapMaterias = new Map(subjectsList.map(s => [s.id_materia, s]));
            
            // 2. AGRUPACIÓN Y ORDENAMIENTO (Usamos filteredStudents en lugar de studentsList)
            const dataAgrupada = {};

            filteredStudents.forEach(alumno => {
              const nombreCarrera = alumno.carrera || alumno.CARRERA || "Sin Carrera";
              const susInscripciones = inscripcionesList.filter(i => i.id_alumno === alumno.id_alumno);
              
              const materiasDelAlumno = susInscripciones.map(ins => {
                const grupo = mapGrupos.get(ins.id_grupo);
                return grupo ? mapMaterias.get(grupo.id_materia) : null;
              }).filter(Boolean);

              const grupoInfo = susInscripciones.length > 0 ? mapGrupos.get(susInscripciones[0].id_grupo) : null;
              const nombreGrupo = grupoInfo ? `Grupo ${grupoInfo.clave_grupo}` : "Sin Grupo";
              
              if (!dataAgrupada[nombreCarrera]) dataAgrupada[nombreCarrera] = {};
              if (!dataAgrupada[nombreCarrera][nombreGrupo]) dataAgrupada[nombreCarrera][nombreGrupo] = [];
              
              dataAgrupada[nombreCarrera][nombreGrupo].push({ ...alumno, materias: materiasDelAlumno });
            });

            const carrerasOrdenadas = Object.keys(dataAgrupada).sort((a, b) => a.localeCompare(b));

            return (
              <div className="space-y-6 animate-fadeIn">
                {/* ENCABEZADO Y ACCIONES */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                  <div>
                    <h2 className="text-2xl font-black text-gray-900">Gestión de Alumnos</h2>
                    <p className="text-xs text-gray-500 mt-1">Administración de matrícula escolar</p>
                  </div>
                  <div className="flex gap-2">
                    <label className="cursor-pointer bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-md transition-all flex items-center">
                      <UploadCloud className="h-4 w-4 mr-2" /> Subir CSV
                      <input type="file" className="hidden" accept=".csv" onChange={handleFileUpload} />
                    </label>
                    <button onClick={() => { if (careersList.length === 0) { triggerNotification('Registre una carrera primero.', 'warning'); return; } setFormStudentCareer(careersList[0]); setShowAddModal('student'); }} className="flex items-center px-4 py-2 text-sm font-bold text-white rounded-lg shadow-md transition-all cursor-pointer" style={{ backgroundColor: brandColors.guinda }}><Plus className="h-4 w-4 mr-2" /> Agregar Alumno</button>
                  </div>
                </div>

                {/* BARRA DE BÚSQUEDA */}
                <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
                  <div className="p-4 bg-gray-50 flex items-center">
                    <Search className="h-5 w-5 text-gray-400 mr-2" />
                    <input 
                      type="text" 
                      placeholder="Buscar alumno por nombre, matrícula o carrera..." 
                      value={searchTerm} 
                      onChange={(e) => setSearchTerm(e.target.value)} 
                      className="w-full bg-transparent border-none text-sm focus:outline-none" 
                    />
                  </div>
                </div>

                {/* REJILLA DE DATOS AGRUPADOS Y CONTRAÍBLES */}
                <div className="space-y-6">
                  {carrerasOrdenadas.length === 0 && (
                     <div className="text-center py-10 bg-white rounded-xl border border-gray-200">
                       <p className="text-gray-500 font-medium">No se encontraron alumnos con esa búsqueda.</p>
                     </div>
                  )}
                  
                  {carrerasOrdenadas.map(carrera => {
                    // MAGIA AQUÍ: Comprobamos si hay texto en el buscador
                    const isSearching = searchTerm.trim().length > 0;
                    
                    // Si está buscando, forzamos a que esté abierto (true). Si no, usamos el estado normal.
                    const isExpanded = isSearching ? true : expandedSubjectCareers[`student_${carrera}`];
                    
                    const toggle = () => {
                      // Evitamos que el usuario lo cierre por accidente mientras busca
                      if (!isSearching) {
                        toggleSubjectCareer(`student_${carrera}`);
                      }
                    };

                    return (
                      <div key={carrera} className="bg-white rounded-xl shadow-sm border overflow-hidden">
                        {/* CABECERA DE CARRERA (CLICKABLE) */}
                        <div 
                          className="px-6 py-4 flex justify-between items-center cursor-pointer hover:opacity-90 transition-opacity" 
                          style={{ backgroundColor: brandColors.guinda }}
                          onClick={toggle}
                        >
                          <h3 className="text-lg font-black uppercase tracking-widest text-white flex items-center">
                            <GraduationCap className="h-5 w-5 mr-3"/> {carrera}
                          </h3>
                          {isExpanded ? <ChevronUp className="text-white h-6 w-6" /> : <ChevronDown className="text-white h-6 w-6" />}
                        </div>
                        
                        {/* CONTENIDO DE LA CARRERA (GRUPOS Y ALUMNOS) */}
                        {isExpanded && (
                          <div className="p-6 space-y-8 bg-gray-50/30 animate-fadeIn">
                            {Object.keys(dataAgrupada[carrera]).sort().map(nombreGrupo => (
                              <div key={`${carrera}-${nombreGrupo}`} className="ml-2 pl-4 border-l-4" style={{ borderColor: brandColors.dorado }}>
                                <div className="flex items-center mb-4 border-b pb-2">
                                  <FolderOpen className="h-5 w-5 mr-2 text-gray-400" />
                                  <h4 className="text-lg font-bold text-gray-800">{nombreGrupo}</h4>
                                </div>
                                
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {dataAgrupada[carrera][nombreGrupo]
                                    .sort((a, b) => a.nombre_completo.localeCompare(b.nombre_completo))
                                    .map(alumno => (
                                      <div key={alumno.id_alumno} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all flex flex-col">
                                        <div className="flex justify-between items-start mb-2">
                                          <h5 className="font-bold text-gray-900 leading-tight">{alumno.nombre_completo}</h5>
                                          <div className="flex gap-2">
                                            <button 
                                              onClick={() => { 
                                                const gruposActuales = inscripcionesList.filter(ins => ins.id_alumno === alumno.id_alumno).map(ins => ins.id_grupo);
                                                setFormSelectedStudents(gruposActuales);
                                                setEditModal({ show: true, type: 'alumno', data: alumno }); 
                                              }} 
                                              className="text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                                            >
                                              <Edit className="h-4 w-4" />
                                            </button>
                                            <button onClick={() => setDeleteConfirmation({ show: true, type: 'alumno', id: alumno.id_alumno })} className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer">
                                              <Trash2 className="h-4 w-4" />
                                            </button>
                                          </div>
                                        </div>
                                        <p className="text-[10px] text-gray-400 font-bold uppercase mb-4">Matrícula: {alumno.numero_control}</p>
                                        
                                        <div className="mt-auto">
                                          <p className="text-[9px] font-bold text-gray-400 uppercase">Materias ({alumno.materias.length}):</p>
                                          <div className="flex flex-wrap gap-1.5 mt-1 max-h-20 overflow-y-auto">
                                            {alumno.materias
                                              .sort((a, b) => a.nombre_materia.localeCompare(b.nombre_materia))
                                              .map(mat => (
                                                <span key={mat.id_materia} className="text-[9px] bg-blue-50 text-blue-700 px-2 py-1 rounded border border-blue-100 font-medium">
                                                  {mat.nombre_materia}
                                                </span>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}
          {/* ============================================================== */}
          {/* PESTAÑA DE MATERIAS                                            */}
          {/* ============================================================== */}
          {adminTab === 'subjects' && (
            <div className="space-y-6">
              {(() => {
                // 1. Enriquecer los datos y agruparlos por Carrera y Grupo
                const groupedSubjects = {};
                
                filteredSubjects.forEach(sub => {
                  const grupoAsociado = groupsList.find(g => g.id_materia == sub.id_materia);
                  const docenteAsignado = grupoAsociado ? teachersList.find(t => t.id_docente == grupoAsociado.id_docente) : null;
                  
                  const carrera = sub.carrera || 'Sin Carrera Especificada';
                  const claveGrupo = grupoAsociado ? grupoAsociado.clave_grupo : 'Sin grupo asignado';
                  const nombreDocente = docenteAsignado ? (docenteAsignado.nombre_completo || docenteAsignado.name) : <span className="text-gray-400 italic font-normal text-xs">Sin docente asignado</span>;
                  
                  if (!groupedSubjects[carrera]) groupedSubjects[carrera] = {};
                  if (!groupedSubjects[carrera][claveGrupo]) groupedSubjects[carrera][claveGrupo] = [];
                  
                  // Guardamos la materia empaquetando también el id del docente y del grupo actuales
                  groupedSubjects[carrera][claveGrupo].push({ 
                    ...sub, 
                    nombreDocente,
                    id_docente: docenteAsignado ? docenteAsignado.id_docente : '',
                    id_grupo: grupoAsociado ? grupoAsociado.id_grupo : ''
                  });
                });

                // 2. Ordenamos alfabéticamente las carreras
                const sortedCarreras = Object.keys(groupedSubjects).sort((a, b) => a.localeCompare(b));

                return (
                  <>
                    {/* ENCABEZADO Y BOTÓN AGREGAR */}
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div><h2 className="text-2xl font-black text-gray-900">Asignaturas (Materias)</h2></div>
                      <button onClick={() => { if (careersList.length === 0) { triggerNotification('Registre carrera.', 'warning'); return; } setFormSubjCareer(careersList[0]); setShowAddModal('subject'); }} className="flex items-center px-4 py-2 text-sm font-bold text-white rounded-lg shadow-md transition-all cursor-pointer" style={{ backgroundColor: brandColors.guinda }}><Plus className="h-4 w-4 mr-2" /> Agregar Materia</button>
                    </div>
                    
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                      {/* BARRA DE BÚSQUEDA */}
                      <div className="p-4 border-b border-gray-100 bg-gray-50 flex items-center">
                        <Search className="h-5 w-5 text-gray-400 mr-2" />
                        <input type="text" placeholder="Buscar materia..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full bg-transparent border-none text-sm focus:outline-none" />
                      </div>
                      
                      {/* TABLA AGRUPADA */}
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-white">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Clave</th>
                              <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Materia</th>
                              <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Docente Asignado</th>
                              <th className="px-6 py-3 text-right text-xs font-bold text-gray-400 uppercase tracking-wider">Acción</th>
                            </tr>
                          </thead>
                          <tbody className="bg-white">
                            {sortedCarreras.length === 0 && (
                              <tr>
                                <td colSpan="4" className="px-6 py-12 text-center text-sm font-medium text-gray-500">No se encontraron materias registradas o que coincidan con la búsqueda.</td>
                              </tr>
                            )}
                            
                            {sortedCarreras.map(carrera => {
                              const sortedGrupos = Object.keys(groupedSubjects[carrera]).sort((a, b) => a.localeCompare(b));
                              
                              // Verificamos si esta carrera en particular está abierta en el estado
                              const isExpanded = expandedSubjectCareers[carrera];
                              
                              return (
                                <React.Fragment key={carrera}>
                                  {/* SEPARADOR DE CARRERA (AHORA ES UN BOTÓN CLICKABLE) */}
                                  <tr 
                                    className="bg-gray-100 border-y border-gray-200 cursor-pointer hover:bg-gray-200 transition-colors select-none"
                                    onClick={() => toggleSubjectCareer(carrera)}
                                  >
                                    <td colSpan="4" className="px-6 py-3">
                                      <div className="flex items-center justify-between w-full">
                                        <div className="flex items-center">
                                          <GraduationCap className="h-5 w-5 mr-3 text-gray-400" />
                                          <span className="text-sm font-black text-gray-800 uppercase tracking-widest">{carrera}</span>
                                        </div>
                                        {/* Icono que cambia dependiendo de si está abierto o cerrado */}
                                        {isExpanded ? <ChevronUp className="h-5 w-5 text-gray-500" /> : <ChevronDown className="h-5 w-5 text-gray-500" />}
                                      </div>
                                    </td>
                                  </tr>
                                  
                                  {/* FILAS DE MATERIAS (Solo se dibujan si isExpanded es true) */}
                                  {isExpanded && sortedGrupos.map(grupo => (
                                    <React.Fragment key={`${carrera}-${grupo}`}>
                                      {/* SEPARADOR DE GRUPO */}
                                      <tr className="bg-gray-50/80 border-b border-gray-100">
                                        <td colSpan="4" className="px-6 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider pl-10">
                                          <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-md shadow-sm border border-gray-300">Grupo {grupo}</span>
                                        </td>
                                      </tr>
                                      
                                      {/* FILAS DE MATERIAS */}
                                      {groupedSubjects[carrera][grupo].map(sub => (
                                        <tr key={sub.id_materia} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-none">
                                          <td className="px-6 py-4 whitespace-nowrap text-sm font-black text-gray-800 pl-12">
                                            <span className="bg-blue-50 text-blue-800 px-2 py-1 rounded border border-blue-100">{sub.clave_materia}</span>
                                          </td>
                                          <td className="px-6 py-4 text-sm font-bold text-gray-900">{sub.nombre_materia}</td>
                                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700">{sub.nombreDocente}</td>
                                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-bold space-x-3">
                                            {/* BOTÓN EDITAR */}
                                            <button 
                                              onClick={(e) => { e.stopPropagation(); setEditModal({ show: true, type: 'materia', data: sub }); }} 
                                              className="text-gray-400 hover:text-blue-600 cursor-pointer transition-colors"
                                            >
                                              <Edit className="h-4 w-4 inline" />
                                            </button>
                                            {/* BOTÓN ELIMINAR */}
                                            <button 
                                              onClick={(e) => { e.stopPropagation(); setDeleteConfirmation({ show: true, type: 'materia', id: sub.id_materia }); }} 
                                              className="text-red-400 hover:text-red-600 cursor-pointer transition-colors"
                                            >
                                              <Trash2 className="h-4 w-4 inline" />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ))}
                                </React.Fragment>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {/* ============================================================== */}
          {/* MODAL EDITAR MATERIA Y DOCENTE                                 */}
          {/* ============================================================== */}
          {editModal.show && editModal.type === 'materia' && (
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 relative border-t-8 max-h-[85vh] flex flex-col" style={{ borderColor: brandColors.guinda }}>
                <button 
                  onClick={() => setEditModal({ show: false, type: '', data: null })} 
                  className="absolute top-4 right-4 text-gray-400 cursor-pointer hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
                
                <div className="mb-6">
                  <h3 className="text-xl font-black text-gray-900">Editar Asignatura</h3>
                  <p className="text-sm font-bold text-gray-500 mt-1">
                    Modifique los datos de la materia y asigne o cambie el docente.
                  </p>
                </div>
                
                {/* CAMPO 1: CLAVE */}
                  <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Clave</label>
                    <input 
                      type="text" 
                      value={editModal.data.clave_materia || ''} 
                      onChange={(e) => setEditModal({ ...editModal, data: { ...editModal.data, clave_materia: e.target.value } })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium focus:outline-none focus:border-blue-500"
                    />
                  </div>

                  {/* CAMPO 2: MATERIA */}
                  <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Materia</label>
                    <input 
                      type="text" 
                      value={editModal.data.nombre_materia || ''} 
                      onChange={(e) => setEditModal({ ...editModal, data: { ...editModal.data, nombre_materia: e.target.value } })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium focus:outline-none focus:border-blue-500"
                    />
                  </div>

                  {/* CAMPO 3: CARRERA (¡EL NUEVO!) */}
                  <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Carrera de la Materia</label>
                    <select
                      value={editModal.data.carrera || ''}
                      onChange={(e) => setEditModal({ ...editModal, data: { ...editModal.data, carrera: e.target.value } })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white focus:outline-none focus:border-blue-500 cursor-pointer"
                    >
                      <option value="">-- Seleccione la carrera correcta --</option>
                      {careersList.map(car => (
                        <option key={car} value={car}>
                          {car}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* CAMPO 4: DOCENTE ASIGNADO */}
                  <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Docente Asignado</label>
                    <select
                      value={editModal.data.id_docente || ''}
                      onChange={(e) => setEditModal({ ...editModal, data: { ...editModal.data, id_docente: e.target.value } })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white focus:outline-none focus:border-blue-500 cursor-pointer"
                    >
                      <option value="">-- Seleccione un docente --</option>
                      {teachersList.map(t => (
                        <option key={t.id_docente} value={t.id_docente}>
                          {t.nombre_completo || t.name}
                        </option>
                      ))}
                    </select>
                  </div>

                <div className="mt-6 pt-4 border-t border-gray-100 flex justify-end space-x-3">
                  <button 
                    onClick={() => setEditModal({ show: false, type: '', data: null })} 
                    className="px-4 py-2 text-sm font-bold text-gray-500 hover:text-gray-700 transition-colors cursor-pointer">
                    Cancelar
                  </button>
                 <button 
                    onClick={processEditEntity} 
                    className="px-4 py-2 text-sm font-bold text-white rounded-lg shadow-md transition-all cursor-pointer"
                    style={{ backgroundColor: brandColors.guinda }}>
                    Guardar Cambios
                  </button>
                </div>
              </div>
            </div>
          )}

          {adminTab === 'groups' && (() => {
  // LÓGICA DE AGRUPACIÓN (Carrera -> Grupo -> Materias)
  const groupedData = {};
  groupsList.forEach(gp => {
    const sub = subjectsList.find(s => s.id_materia == gp.id_materia);
    const carrera = sub ? sub.carrera : (gp.carrera || "Sin Carrera");
    const claveGrupo = gp.clave_grupo || "Sin Grupo";
    
    if (!groupedData[carrera]) groupedData[carrera] = {};
    if (!groupedData[carrera][claveGrupo]) groupedData[carrera][claveGrupo] = [];
    
    groupedData[carrera][claveGrupo].push(gp);
  });

  const sortedCarreras = Object.keys(groupedData).sort((a, b) => a.localeCompare(b));

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div><h2 className="text-2xl font-black text-gray-900">Grupos e Inscripciones</h2></div>
        <button 
          onClick={() => {
            if (teachersList.length === 0 || subjectsList.length === 0) {
              triggerNotification('Requiere docentes y materias.', 'warning');
              return;
            }
            const carreraInicial = careersList[0] || subjectsList[0]?.carrera || '';
            setFormGroupCareer(carreraInicial);
            setFormGroupCode('');
            setFormGroupSelectedSubjects([]);
            setFormGroupTeacherBySubject({});
            setFormSelectedStudents([]);
            setShowAddModal('group');
          }} 
          className="flex items-center px-4 py-2 text-sm font-bold text-white rounded-lg shadow-md transition-all cursor-pointer" 
          style={{ backgroundColor: brandColors.guinda }}
        >
          <Plus className="h-4 w-4 mr-2" /> Nuevo Grupo
        </button>
      </div>
      
      <div className="space-y-4">
        {sortedCarreras.map(carrera => {
          const sortedGrupos = Object.keys(groupedData[carrera]).sort((a, b) => a.localeCompare(b));
          // Reutilizamos tu lógica de estado existente (ej. expandedSubjectCareers) 
          // o puedes crear un estado específico si prefieres que se abran/cierren por separado
          const isExpanded = expandedSubjectCareers[carrera]; 

          return (
            <div key={carrera} className="bg-white rounded-xl shadow-sm border overflow-hidden">
              {/* CABECERA CLICKABLE PARA CONTRAER */}
              <div 
                className="px-6 py-4 flex justify-between items-center cursor-pointer hover:opacity-90 transition-opacity" 
                style={{ backgroundColor: brandColors.guinda }}
                onClick={() => toggleSubjectCareer(carrera)}
              >
                <h3 className="text-lg font-black uppercase tracking-widest text-white flex items-center">
                  <GraduationCap className="h-5 w-5 mr-3"/> {carrera}
                </h3>
                {isExpanded ? <ChevronUp className="text-white h-6 w-6" /> : <ChevronDown className="text-white h-6 w-6" />}
              </div>
              
              {/* CONTENIDO CONTRAÍBLE */}
              {isExpanded && (
                <div className="p-6 space-y-8 bg-gray-50/30 animate-fadeIn">
                  {sortedGrupos.map(claveGrupo => (
                    <div key={claveGrupo}>
                      <div className="flex items-center mb-4 border-b pb-2">
                        <FolderOpen className="h-5 w-5 mr-2 text-gray-400" />
                        <h4 className="text-lg font-bold text-gray-800">Grupo {claveGrupo}</h4>
                      </div>
                      
                      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                        {groupedData[carrera][claveGrupo].map(gp => {
                          const enrollCount = inscripcionesList.filter(ins => ins.id_grupo == gp.id_grupo).length;
                          const sub = subjectsList.find(s => s.id_materia == gp.id_materia);
                          const teacher = teachersList.find(t => t.id_docente == gp.id_docente);
                          
                          return (
                            <div key={gp.id_grupo} className="bg-white rounded-lg border border-gray-200 p-4 hover:border-yellow-500 hover:shadow-md transition-all flex flex-col justify-between">
                              <div>
                                <div className="flex justify-between items-start mb-2">
                                  <span className="text-[10px] font-bold bg-blue-50 text-blue-800 px-2 py-1 rounded border border-blue-100">{sub?.clave_materia || gp.clave_materia}</span>
                                  <button onClick={() => setDeleteConfirmation({ show: true, type: 'grupo', id: gp.id_grupo })} className="text-gray-300 hover:text-red-500 cursor-pointer transition-colors"><Trash2 className="h-4 w-4" /></button>
                                </div>
                                <h5 className="font-bold text-gray-900 leading-tight mb-1">{sub ? sub.nombre_materia : gp.materia}</h5>
                                <p className="text-xs text-gray-500 font-medium line-clamp-1">Docente: {teacher ? teacher.name : gp.docente}</p>
                              </div>
                              <div className="mt-4 pt-3 border-t border-gray-100">
                                <button onClick={() => setViewStudentsModal(gp)} className="w-full flex justify-between items-center px-3 py-2 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded text-xs font-bold text-gray-700 transition-colors cursor-pointer">
                                  <span>{enrollCount} Alumnos Inscritos</span>
                                  <Users className="h-4 w-4 text-gray-400" />
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  );
})()}
          {/* --- MODAL VER ALUMNOS INSCRITOS --- */}
          {viewStudentsModal && (
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 relative border-t-8 max-h-[85vh] flex flex-col" style={{ borderColor: brandColors.guinda }}>
                <button onClick={() => setViewStudentsModal(null)} className="absolute top-4 right-4 text-gray-400 cursor-pointer hover:text-gray-600"><X className="h-6 w-6" /></button>
                
                <div className="mb-6">
                  <h3 className="text-xl font-black text-gray-900">Alumnos Inscritos</h3>
                  <p className="text-sm font-bold text-gray-500 mt-1">
                    Grupo {viewStudentsModal.clave_grupo} • {subjectsList.find(s => s.id_materia == viewStudentsModal.id_materia)?.nombre_materia || viewStudentsModal.materia}
                  </p>
                </div>
                
                <div className="overflow-y-auto flex-1 pr-2">
                  {(() => {
                    const enrolledIds = inscripcionesList.filter(ins => ins.id_grupo == viewStudentsModal.id_grupo).map(i => i.id_alumno);
                    const enrolledStudents = studentsList.filter(st => enrolledIds.includes(st.id_alumno));
                    
                    if (enrolledStudents.length === 0) return <p className="text-gray-500 text-center py-8">No hay alumnos en este grupo.</p>;
                    
                    return (
                      <div className="border rounded-lg divide-y divide-gray-100">
                        {enrolledStudents.map((st, idx) => (
                          <div key={st.id_alumno} className="p-3 hover:bg-gray-50 flex justify-between items-center transition-colors">
                            <div className="flex items-center">
                              <span className="text-xs font-bold text-gray-400 w-6">{idx + 1}.</span>
                              <div>
                                <p className="text-sm font-bold text-gray-900">{st.nombre_completo}</p>
                                <p className="text-[10px] text-gray-500 font-medium">Matrícula: {st.numero_control}</p>
                              </div>
                            </div>
                            {inscripcionesList.find(i => i.id_grupo == viewStudentsModal.id_grupo && i.id_alumno == st.id_alumno)?.evaluacion_completada ? 
                              <span className="text-xs font-bold bg-green-100 text-green-700 px-2 py-1 rounded-full flex items-center border border-green-200"><Check className="w-3 h-3 mr-1"/> Evaluó</span> : 
                              <span className="text-xs font-bold bg-yellow-50 text-yellow-600 px-2 py-1 rounded-full border border-yellow-200">Pendiente</span>
                            }
                          </div>
                        ))}
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          )}

          {adminTab === 'validar_acuse' && (
            <div className="space-y-6 animate-fadeIn">
              <div>
                <h2 className="text-2xl font-black text-gray-900">Validación de Acuses</h2>
                <p className="text-xs text-gray-500 mt-1">Verifica la autenticidad de un acuse de evaluación docente capturando la matrícula y el folio o código de verificación.</p>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 max-w-xl">
                <form onSubmit={validarAcuseControlEscolar} className="space-y-4">
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Matrícula del alumno</label>
                    <input
                      type="text"
                      required
                      value={validacionAcuse.numero_control}
                      onChange={(e) => setValidacionAcuse({ ...validacionAcuse, numero_control: e.target.value.toUpperCase() })}
                      placeholder="Ej. 20230001"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium focus:outline-none focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Folio del acuse</label>
                    <input
                      type="text"
                      value={validacionAcuse.folio}
                      onChange={(e) => setValidacionAcuse({ ...validacionAcuse, folio: e.target.value.toUpperCase() })}
                      placeholder="Ej. ITSA-EVDOC-2026-20230001"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium focus:outline-none focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Código de verificación (alternativo al folio)</label>
                    <input
                      type="text"
                      value={validacionAcuse.codigo_verificacion}
                      onChange={(e) => setValidacionAcuse({ ...validacionAcuse, codigo_verificacion: e.target.value.toUpperCase() })}
                      placeholder="Ej. ABCD-1234-EFGH-5678"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium focus:outline-none focus:border-blue-500 font-mono"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-2.5 text-white font-bold rounded-lg text-sm cursor-pointer flex items-center justify-center"
                    style={{ backgroundColor: brandColors.guinda }}
                  >
                    {loading ? <><Loader2 className="animate-spin h-4 w-4 mr-2" /> Verificando...</> : 'Verificar Acuse'}
                  </button>
                </form>

                {resultadoValidacion && (
                  <div className={`mt-6 p-4 rounded-lg border ${resultadoValidacion.valido ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
                    {resultadoValidacion.valido ? (
                      <>
                        <p className="font-black text-green-700 flex items-center gap-2 mb-3"><CheckCircle className="h-5 w-5" /> Acuse válido y auténtico</p>
                        <div className="space-y-1 text-sm text-gray-700">
                          <p><span className="font-bold">Alumno:</span> {resultadoValidacion.acuse?.nombre_completo}</p>
                          <p><span className="font-bold">Matrícula:</span> {resultadoValidacion.acuse?.numero_control}</p>
                          <p><span className="font-bold">Carrera:</span> {resultadoValidacion.acuse?.carrera}</p>
                          <p><span className="font-bold">Periodo:</span> {resultadoValidacion.acuse?.periodo}</p>
                          <p><span className="font-bold">Evaluaciones:</span> {resultadoValidacion.acuse?.total_evaluadas} de {resultadoValidacion.acuse?.total_materias}</p>
                          <p><span className="font-bold">Fecha de emisión:</span> {resultadoValidacion.acuse?.fecha_generacion}</p>
                          <p className="font-mono text-xs text-gray-500 mt-2 break-all"><span className="font-bold font-sans">Hash:</span> {resultadoValidacion.acuse?.hash_registro}</p>
                        </div>
                      </>
                    ) : (
                      <p className="font-black text-red-700 flex items-center gap-2"><AlertCircle className="h-5 w-5" /> {resultadoValidacion.mensaje || 'Acuse no encontrado o datos incorrectos.'}</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {adminTab === 'acuses' && (
            <div className="space-y-6 animate-fadeIn">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <h2 className="text-2xl font-black text-gray-900">Acuses de Alumnos</h2>
                  <p className="text-xs text-gray-500 mt-1">Consulta y descarga los acuses generados al concluir la evaluación docente.</p>
                </div>
                <button onClick={fetchCatalogosSecundarios} className="flex items-center px-4 py-2 text-sm font-bold rounded-lg border bg-white text-gray-700 shadow-sm">
                  <RefreshCw className="h-4 w-4 mr-2" /> Actualizar
                </button>
              </div>

              <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
                <div className="p-4 border-b border-gray-100 bg-gray-50 flex items-center">
                  <Search className="h-5 w-5 text-gray-400 mr-2" />
                  <input type="text" placeholder="Buscar por folio, matrícula, alumno, carrera o periodo..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full bg-transparent border-none text-sm focus:outline-none" />
                </div>

                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-white">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Folio</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Código</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Alumno</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Carrera</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Periodo</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">Evaluaciones</th>
                        <th className="px-6 py-3 text-right text-xs font-bold text-gray-400 uppercase tracking-wider">Acción</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                      {filteredAcuses.length === 0 ? (
                        <tr><td colSpan="7" className="px-6 py-10 text-center text-sm text-gray-500">Aún no hay acuses generados.</td></tr>
                      ) : filteredAcuses.map(acuse => (
                        <tr key={acuse.id_acuse} className="hover:bg-gray-50">
                          <td className="px-6 py-4 text-xs font-black text-gray-900 whitespace-nowrap">{acuse.folio}</td>
                          <td className="px-6 py-4 text-[11px] font-bold text-emerald-700 whitespace-nowrap">
                            {acuse.codigo_verificacion || '—'}
                          </td>
                          <td className="px-6 py-4 text-sm">
                            <p className="font-bold text-gray-900">{acuse.nombre_completo}</p>
                            <p className="text-xs text-gray-500">{acuse.numero_control}</p>
                          </td>
                          <td className="px-6 py-4 text-xs font-semibold text-gray-700">{acuse.carrera}</td>
                          <td className="px-6 py-4 text-xs font-bold text-gray-600">{acuse.periodo}</td>
                          <td className="px-6 py-4 text-xs font-bold text-green-700">{acuse.total_evaluadas} de {acuse.total_materias}</td>
                          <td className="px-6 py-4 text-right">
                            <button onClick={() => descargarAcuseAdmin(acuse.id_acuse)} className="inline-flex items-center px-3 py-1.5 text-xs font-bold rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
                              <FileText className="h-3.5 w-3.5 mr-1" /> Descargar PDF
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {adminTab === 'settings' && (
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-black text-gray-900">Configuración Escolar</h2>
                <p className="text-xs text-gray-500 mt-1">Usuarios, perfiles, catálogos y bitácora de cambios</p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 border-l-4" style={{ borderColor: brandColors.guinda }}>
                <h3 className="text-lg font-bold text-gray-950 mb-2">Sesión actual</h3>
                <p className="text-sm text-gray-700">Usuario: <strong>{currentUser?.nombre || 'Administrador'}</strong></p>
                <p className="text-sm text-gray-700">Perfil: <strong>{currentUser?.rol_label || currentUser?.rol || 'Administrador'}</strong></p>
                <p className="text-xs text-gray-500 mt-2">Los perfiles no administradores pueden editar información académica, pero no pueden eliminar registros.</p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 border-l-4" style={{ borderColor: Number(systemConfig?.evaluacion_abierta) === 1 ? '#10B981' : '#EF4444' }}>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div>
                    <h3 className="text-lg font-bold text-gray-950">Periodo de evaluación</h3>
                    <p className="text-sm text-gray-700 mt-1">Periodo activo: <strong>{systemConfig?.periodo_activo}</strong></p>
                    <p className="text-xs text-gray-500 mt-1">Al cerrar el periodo, los alumnos ya no podrán enviar evaluaciones. Los reportes y consultas seguirán disponibles.</p>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-2">
                    <input
                      type="text"
                      value={systemConfig?.periodo_activo || ''}
                      onChange={(e) => setSystemConfig(prev => ({ ...prev, periodo_activo: e.target.value }))}
                      className="px-3 py-2 border rounded-lg text-sm font-semibold"
                      disabled={!(isAdmin || isGestor)}
                    />
                    {(isAdmin || isGestor) && (
                      <>
                        <button
                          onClick={() => actualizarConfiguracionSistema({ ...systemConfig, evaluacion_abierta: 1 })}
                          className="px-4 py-2 text-sm font-black rounded-lg bg-green-600 text-white shadow-sm"
                        >
                          Abrir
                        </button>
                        <button
                          onClick={() => actualizarConfiguracionSistema({ ...systemConfig, evaluacion_abierta: 0 })}
                          className="px-4 py-2 text-sm font-black rounded-lg bg-red-600 text-white shadow-sm"
                        >
                          Cerrar
                        </button>
                      </>
                    )}
                  </div>
                </div>
                <div className="mt-4">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-black border ${Number(systemConfig?.evaluacion_abierta) === 1 ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                    Estado: {Number(systemConfig?.evaluacion_abierta) === 1 ? 'ABIERTO' : 'CERRADO'}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
                  <h3 className="text-lg font-bold text-gray-950">Academias</h3>
                  <form onSubmit={handleAddAcademy} className="flex gap-2">
                    <input type="text" required placeholder="Nueva Academia" value={newAcademyName} onChange={(e) => setNewAcademyName(e.target.value)} className="flex-1 p-2 text-sm border rounded-lg" />
                    <button type="submit" className="px-4 py-2 text-sm font-bold text-white rounded-lg cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Añadir</button>
                  </form>
                  <div className="border rounded-lg overflow-hidden divide-y">
                    {academiesList.map(academy => (
                      <div key={academy} className="p-3 flex justify-between">
                        <span className="text-sm font-medium">{academy}</span>
                        {canDeleteRecords && (
                          <button onClick={() => handleDeleteAcademy(academy)} className="text-red-500 cursor-pointer"><Trash2 className="h-4 w-4" /></button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
                  <h3 className="text-lg font-bold text-gray-950">Carreras</h3>
                  <form onSubmit={handleAddCareer} className="flex gap-2">
                    <input type="text" required placeholder="Nueva Carrera" value={newCareerName} onChange={(e) => setNewCareerName(e.target.value)} className="flex-1 p-2 text-sm border rounded-lg" />
                    <button type="submit" className="px-4 py-2 text-sm font-bold text-white rounded-lg cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Añadir</button>
                  </form>
                  <div className="border rounded-lg overflow-hidden divide-y">
                    {careersList.map(career => (
                      <div key={career} className="p-3 flex justify-between">
                        <span className="text-sm font-medium">{career}</span>
                        {canDeleteRecords && (
                          <button onClick={() => handleDeleteCareer(career)} className="text-red-500 cursor-pointer"><Trash2 className="h-4 w-4" /></button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {isAdmin && (
                <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
                  <h3 className="text-lg font-bold text-gray-950">Usuarios y perfiles</h3>
                  <form onSubmit={processAddSystemUser} className="grid grid-cols-1 md:grid-cols-5 gap-3">
                    <input required type="text" placeholder="Nombre" value={newSystemUser.nombre} onChange={(e) => setNewSystemUser({...newSystemUser, nombre: e.target.value})} className="p-2 text-sm border rounded-lg" />
                    <input required type="text" placeholder="Usuario" value={newSystemUser.usuario} onChange={(e) => setNewSystemUser({...newSystemUser, usuario: e.target.value})} className="p-2 text-sm border rounded-lg" />
                    <input required type="text" placeholder="Contraseña" value={newSystemUser.password} onChange={(e) => setNewSystemUser({...newSystemUser, password: e.target.value})} className="p-2 text-sm border rounded-lg" />
                    <select value={newSystemUser.rol} onChange={(e) => setNewSystemUser({...newSystemUser, rol: e.target.value})} className="p-2 text-sm border rounded-lg bg-white">
                      <option value="administrador">Administrador</option>
                      <option value="gestor">Gestor Desarrollo Académico</option>
                      <option value="jefe_division">Jefe de División</option>
                      <option value="docente">Docente</option>
                      <option value="control_escolar">Control Escolar</option>
                    </select>
                    <button type="submit" className="px-4 py-2 text-sm font-bold text-white rounded-lg cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Crear</button>
                  </form>

                  <div className="border rounded-lg overflow-hidden divide-y">
                    {systemUsersList.map(user => (
                      <div key={user.id_usuario} className="p-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div>
                          <p className="text-sm font-bold text-gray-900">{user.nombre}</p>
                          <p className="text-xs text-gray-500">
                            {user.usuario} • {user.rol} • {user.carrera_asignada || 'Todas'} • {user.activo ? 'Activo' : 'Inactivo'}
                          </p>
                        </div>

                        <div className="flex flex-wrap gap-2">
                          <button
                            type="button"
                            onClick={() => abrirEdicionUsuario(user)}
                            className="px-3 py-1.5 text-xs font-bold rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 cursor-pointer"
                          >
                            Editar / Contraseña
                          </button>

                          {user.activo ? (
                            <button
                              type="button"
                              onClick={() => cambiarEstadoUsuario(user, 0)}
                              disabled={user.usuario === currentUser?.usuario}
                              className="px-3 py-1.5 text-xs font-bold rounded-lg border border-orange-200 text-orange-700 bg-orange-50 hover:bg-orange-100 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                              title={user.usuario === currentUser?.usuario ? 'No puedes desactivar tu propio usuario' : 'Desactivar usuario'}
                            >
                              Desactivar
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => cambiarEstadoUsuario(user, 1)}
                              className="px-3 py-1.5 text-xs font-bold rounded-lg border border-green-200 text-green-700 bg-green-50 hover:bg-green-100 cursor-pointer"
                            >
                              Reactivar
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="bg-white rounded-xl shadow-sm p-6 space-y-4">
                <h3 className="text-lg font-bold text-gray-950">Bitácora de cambios</h3>
                <div className="border rounded-lg overflow-hidden divide-y max-h-80 overflow-y-auto">
                  {auditLogList.length === 0 ? (
                    <p className="p-4 text-sm text-gray-500">Sin movimientos registrados.</p>
                  ) : auditLogList.map(log => (
                    <div key={log.id_log} className="p-3">
                      <p className="text-sm font-bold text-gray-900">{log.accion} en {log.tabla}</p>
                      <p className="text-xs text-gray-500">{log.usuario} • {log.rol} • {log.fecha}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </main>

        {/* --- MODAL EDITAR ENTIDAD --- */}
        {editModal.show && editModal.data && editModal.type !== 'materia' && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative border-t-8 border-blue-600">
              <button onClick={() => setEditModal({ show: false, type: null, data: null })} className="absolute top-4 right-4 text-gray-400 cursor-pointer"><X className="h-6 w-6" /></button>
              <h3 className="text-lg font-black text-gray-900 mb-4 capitalize">Editar {editModal.type}</h3>
              <form onSubmit={processEditEntity} className="space-y-4">
                
                {editModal.type === 'docente' && (
                  <>
                    <input required type="text" value={editModal.data.name} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, name: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Nombre Completo" />
                    <input required type="text" value={editModal.data.employee_number} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, employee_number: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm" placeholder="No. Empleado" />
                    <select value={editModal.data.department} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, department: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm bg-white">{academiesList.map(ac => (<option key={ac} value={ac}>{ac}</option>))}</select>
                  </>
                )}

                {editModal.type === 'usuario_sistema' && (
                  <>
                    <input
                      required
                      type="text"
                      value={editModal.data.nombre || ''}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, nombre: e.target.value}})}
                      className="w-full p-2.5 border rounded-lg text-sm"
                      placeholder="Nombre completo"
                    />
                    <input
                      required
                      type="text"
                      value={editModal.data.usuario || ''}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, usuario: e.target.value}})}
                      className="w-full p-2.5 border rounded-lg text-sm"
                      placeholder="Usuario"
                    />
                    <input
                      type="text"
                      value={editModal.data.password || ''}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, password: e.target.value}})}
                      className="w-full p-2.5 border rounded-lg text-sm"
                      placeholder="Nueva contraseña (dejar vacío para conservar la actual)"
                    />
                    <select
                      value={editModal.data.rol || 'jefe_division'}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, rol: e.target.value}})}
                      className="w-full p-2.5 border rounded-lg text-sm bg-white"
                    >
                      <option value="administrador">Administrador</option>
                      <option value="gestor">Gestor Desarrollo Académico</option>
                      <option value="jefe_division">Jefe de División</option>
                      <option value="docente">Docente</option>
                      <option value="control_escolar">Control Escolar</option>
                    </select>
                    <input
                      type="text"
                      value={editModal.data.carrera_asignada || 'Todas'}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, carrera_asignada: e.target.value}})}
                      className="w-full p-2.5 border rounded-lg text-sm"
                      placeholder="Carrera asignada"
                    />
                    <select
                      value={Number(editModal.data.activo ?? 1)}
                      onChange={(e) => setEditModal({...editModal, data: {...editModal.data, activo: Number(e.target.value)}})}
                      className="w-full p-2.5 border rounded-lg text-sm bg-white"
                    >
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </select>
                    <p className="text-xs text-gray-500 bg-gray-50 p-3 rounded-lg border">
                      Para conservar la contraseña actual, deja vacío el campo de nueva contraseña. Se recomienda desactivar usuarios en lugar de borrarlos para mantener la bitácora histórica.
                    </p>
                  </>
                )}

                {editModal.type === 'alumno' && (
  <>
    <input required type="text" value={editModal.data.nombre_completo} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, nombre_completo: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Nombre Completo" />
    <div className="grid grid-cols-2 gap-4">
      <input required type="text" value={editModal.data.numero_control} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, numero_control: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Matrícula" />
      <input required type="number" min="1" max="12" value={editModal.data.semestre} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, semestre: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Semestre" />
    </div>
    <select value={editModal.data.carrera} onChange={(e) => setEditModal({...editModal, data: {...editModal.data, carrera: e.target.value}})} className="w-full p-2.5 border rounded-lg text-sm bg-white">
      {careersList.map(car => (<option key={car} value={car}>{car}</option>))}
    </select>

    {/* LISTADO DE MATERIAS PARA ACTUALIZAR */}
    {editModal.data.carrera && (
      <div>
        <p className="text-xs font-bold text-gray-500 mb-2 uppercase">Actualizar materias inscritas:</p>
        <div className="border rounded-lg max-h-40 overflow-y-auto divide-y bg-gray-50">
          {groupsList
            .filter(g => subjectsList.find(s => s.id_materia === g.id_materia)?.carrera === editModal.data.carrera)
            .map(grupo => {
              const mat = subjectsList.find(s => s.id_materia === grupo.id_materia);
              return (
                <label key={grupo.id_grupo} className="flex items-center p-2 hover:bg-white cursor-pointer text-sm transition-colors">
                  <input 
                    type="checkbox" 
                    className="mr-3 h-4 w-4" 
                    checked={formSelectedStudents.includes(grupo.id_grupo)}
                    onChange={() => handleToggleSelectStudent(grupo.id_grupo)} 
                  />
                  <span className="font-medium text-gray-700">
                    {mat?.nombre_materia || 'Materia'} <span className="text-xs text-gray-400">({grupo.clave_grupo})</span>
                  </span>
                </label>
              );
            })}
        </div>
      </div>
    )}
  </>
)}

                

                <button type="submit" className="w-full py-3 text-white rounded-lg font-bold text-sm bg-blue-600 hover:bg-blue-700 cursor-pointer">Actualizar Datos</button>
              </form>
            </div>
          </div>
        )}

        {/* Modales Crud (Agregar) */}
        {showAddModal === 'teacher' && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative border-t-8" style={{ borderColor: brandColors.guinda }}>
              <button onClick={() => setShowAddModal(null)} className="absolute top-4 right-4 text-gray-400 cursor-pointer"><X className="h-6 w-6" /></button>
              <h3 className="text-lg font-black text-gray-900 mb-4">Registrar Docente</h3>
              <form onSubmit={processAddTeacher} className="space-y-4">
                <input required type="text" value={formTeacherName} onChange={(e) => setFormTeacherName(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Nombre Completo" />
                <input required type="text" value={formTeacherEmpId} onChange={(e) => setFormTeacherEmpId(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="No. Empleado" />
                <select value={formTeacherDept} onChange={(e) => setFormTeacherDept(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm bg-white">{academiesList.map(ac => (<option key={ac} value={ac}>{ac}</option>))}</select>
                <button type="submit" className="w-full py-3 text-white rounded-lg font-bold text-sm cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Guardar</button>
              </form>
            </div>
          </div>
        )}

        {showAddModal === 'student' && (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 relative border-t-8 max-h-[90vh] flex flex-col" style={{ borderColor: brandColors.guinda }}>
      <button onClick={() => setShowAddModal(null)} className="absolute top-4 right-4 text-gray-400 cursor-pointer hover:text-gray-600"><X className="h-6 w-6" /></button>
      
      <h3 className="text-lg font-black text-gray-900 mb-4">Registrar Nuevo Alumno</h3>
      
      <form onSubmit={processAddStudent} className="space-y-4 overflow-y-auto pr-1 flex-1">
        <input required type="text" onChange={(e) => setFormStudentName(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Nombre Completo" />
        
        <div className="grid grid-cols-2 gap-4">
          <input required type="text" onChange={(e) => setFormStudentCtrl(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Matrícula" />
          <input required type="number" min="1" max="12" onChange={(e) => setFormStudentSemester(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Semestre" />
        </div>

        <select required onChange={(e) => setFormStudentCareer(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm bg-white">
          <option value="">-- Seleccione la Carrera --</option>
          {careersList.map(car => <option key={car} value={car}>{car}</option>)}
        </select>

        {/* LISTADO DE MATERIAS FILTRADAS POR CARRERA */}
        {formStudentCareer && (
          <div>
            <p className="text-xs font-bold text-gray-500 mb-2 uppercase">Inscribir a materias:</p>
            <div className="border rounded-lg max-h-40 overflow-y-auto divide-y bg-gray-50">
              {groupsList
                .filter(g => subjectsList.find(s => s.id_materia === g.id_materia)?.carrera === formStudentCareer)
                .map(grupo => {
                  const mat = subjectsList.find(s => s.id_materia === grupo.id_materia);
                  return (
                    <label key={grupo.id_grupo} className="flex items-center p-2 hover:bg-white cursor-pointer text-sm">
                      <input type="checkbox" className="mr-3 h-4 w-4" onChange={() => handleToggleSelectStudent(grupo.id_grupo)} />
                      <span>{mat?.nombre_materia || 'Materia'} ({grupo.clave_grupo})</span>
                    </label>
                  );
                })}
            </div>
          </div>
        )}
        
        <button type="submit" className="w-full py-3 text-white rounded-lg font-bold text-sm cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Guardar Alumno</button>
      </form>
    </div>
  </div>
)}

        {showAddModal === 'subject' && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative border-t-8" style={{ borderColor: brandColors.guinda }}>
              <button onClick={() => setShowAddModal(null)} className="absolute top-4 right-4 text-gray-400 cursor-pointer"><X className="h-6 w-6" /></button>
              <h3 className="text-lg font-black text-gray-900 mb-4">Registrar Materia</h3>
              <form onSubmit={processAddSubject} className="space-y-4">
                <input required type="text" value={formSubjName} onChange={(e) => setFormSubjName(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Asignatura" />
                <input required type="text" value={formSubjCode} onChange={(e) => setFormSubjCode(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm" placeholder="Clave" />
                <select value={formSubjCareer} onChange={(e) => setFormSubjCareer(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm bg-white">{careersList.map(car => (<option key={car} value={car}>{car}</option>))}</select>
                
                {/* NUEVO SELECTOR DE DOCENTE */}
                <select value={formSubjTeacher} onChange={(e) => setFormSubjTeacher(e.target.value)} className="w-full p-2.5 border rounded-lg text-sm bg-white cursor-pointer">
                  <option value="">-- Asignar Docente (Opcional) --</option>
                  {teachersList.map(t => (
                    <option key={t.id_docente} value={t.id_docente}>{t.name}</option>
                  ))}
                </select>

                <button type="submit" className="w-full py-3 text-white rounded-lg font-bold text-sm cursor-pointer" style={{ backgroundColor: brandColors.guinda }}>Guardar</button>
              </form>
            </div>
          </div>
        )}

        {showAddModal === 'group' && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full p-6 relative border-t-8 max-h-[92vh] flex flex-col" style={{ borderColor: brandColors.guinda }}>
              <button
                onClick={() => setShowAddModal(null)}
                className="absolute top-4 right-4 text-gray-400 cursor-pointer hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>

              <div className="mb-5 pr-8">
                <h3 className="text-xl font-black text-gray-900">Abrir Grupo y Matricular</h3>
                <p className="text-xs text-gray-500 mt-1">
                  Seleccione la carrera, capture la clave del grupo y el sistema mostrará las materias del semestre correspondiente.
                </p>
              </div>

              <form onSubmit={processAddGroup} className="space-y-5 overflow-y-auto pr-1 flex-1">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">1. Carrera</label>
                    <select
                      value={formGroupCareer}
                      onChange={(e) => {
                        setFormGroupCareer(e.target.value);
                        setFormGroupSelectedSubjects([]);
                        setFormGroupTeacherBySubject({});
                        setFormSelectedStudents([]);
                      }}
                      className="w-full p-2.5 border rounded-lg text-sm bg-white font-semibold cursor-pointer"
                      required
                    >
                      <option value="">-- Seleccione carrera --</option>
                      {careersList.map(car => (
                        <option key={car} value={car}>{car}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">2. Clave del grupo</label>
                    <input
                      required
                      type="text"
                      value={formGroupCode}
                      onChange={(e) => {
                        setFormGroupCode(e.target.value.toUpperCase());
                        setFormGroupSelectedSubjects([]);
                        setFormGroupTeacherBySubject({});
                      }}
                      className="w-full p-2.5 border rounded-lg text-sm font-bold uppercase"
                      placeholder="Ej. 02A, 04B, 06A"
                    />
                    <p className="text-[10px] text-gray-400 mt-1">
                      {semestreGrupoDetectado
                        ? `Semestre detectado: ${semestreGrupoDetectado}`
                        : 'El semestre se toma de los primeros números del grupo.'}
                    </p>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Periodo</label>
                    <input
                      required
                      type="text"
                      value={formGroupPeriod}
                      onChange={(e) => setFormGroupPeriod(e.target.value)}
                      className="w-full p-2.5 border rounded-lg text-sm font-semibold"
                      placeholder="Periodo"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                  <div className="border rounded-xl overflow-hidden bg-white">
                    <div className="p-4 border-b bg-gray-50">
                      <h4 className="text-sm font-black text-gray-900 uppercase tracking-wide">3. Materias del semestre</h4>
                      <p className="text-xs text-gray-500 mt-1">
                        {formGroupCareer && semestreGrupoDetectado
                          ? `${materiasFiltradasParaGrupo.length} materia(s) encontradas para semestre ${semestreGrupoDetectado}.`
                          : 'Seleccione carrera y escriba la clave del grupo.'}
                      </p>
                    </div>

                    <div className="max-h-72 overflow-y-auto divide-y">
                      {(!formGroupCareer || !semestreGrupoDetectado) ? (
                        <div className="p-6 text-sm text-gray-400 text-center">Primero seleccione carrera y capture grupo.</div>
                      ) : materiasFiltradasParaGrupo.length === 0 ? (
                        <div className="p-6 text-sm text-red-500 text-center font-semibold">
                          No hay materias registradas para esa carrera y semestre.
                        </div>
                      ) : (
                        materiasFiltradasParaGrupo.map(materia => {
                          const selected = formGroupSelectedSubjects.includes(materia.id_materia);
                          return (
                            <div key={materia.id_materia} className="p-3 hover:bg-gray-50 transition-colors">
                              <label className="flex items-start gap-3 cursor-pointer">
                                <input
                                  type="checkbox"
                                  className="mt-1 h-4 w-4"
                                  checked={selected}
                                  onChange={() => handleToggleGroupSubject(materia.id_materia)}
                                />
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-black text-gray-900 leading-tight">{materia.nombre_materia}</p>
                                  <p className="text-[10px] text-blue-700 font-bold mt-1">{materia.clave_materia}</p>

                                  {selected && (
                                    <div className="mt-2">
                                      <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Docente asignado</label>
                                      <select
                                        value={formGroupTeacherBySubject[materia.id_materia] || ''}
                                        onChange={(e) => setFormGroupTeacherBySubject(prev => ({
                                          ...prev,
                                          [materia.id_materia]: e.target.value
                                        }))}
                                        className="w-full p-2 border rounded-lg text-xs bg-white font-semibold"
                                        required
                                      >
                                        <option value="">-- Seleccione docente --</option>
                                        {teachersList.map(t => (
                                          <option key={t.id_docente} value={t.id_docente}>{t.name}</option>
                                        ))}
                                      </select>
                                    </div>
                                  )}
                                </div>
                              </label>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>

                  <div className="border rounded-xl overflow-hidden bg-white">
                    <div className="p-4 border-b bg-gray-50">
                      <h4 className="text-sm font-black text-gray-900 uppercase tracking-wide">4. Matricular alumnos</h4>
                      <p className="text-xs text-gray-500 mt-1">
                        {formGroupCareer
                          ? `${alumnosFiltradosParaGrupo.length} alumno(s) de la carrera seleccionada.`
                          : 'Seleccione carrera para filtrar alumnos.'}
                      </p>
                    </div>

                    <div className="max-h-72 overflow-y-auto divide-y">
                      {!formGroupCareer ? (
                        <div className="p-6 text-sm text-gray-400 text-center">Seleccione carrera para ver alumnos.</div>
                      ) : alumnosFiltradosParaGrupo.length === 0 ? (
                        <div className="p-6 text-sm text-red-500 text-center font-semibold">
                          No hay alumnos registrados para esta carrera.
                        </div>
                      ) : (
                        alumnosFiltradosParaGrupo.map(st => (
                          <label key={st.id_alumno} className="flex items-start p-3 hover:bg-gray-50 cursor-pointer text-sm transition-colors">
                            <input
                              type="checkbox"
                              checked={formSelectedStudents.includes(st.id_alumno)}
                              onChange={() => handleToggleSelectStudent(st.id_alumno)}
                              className="mr-3 mt-1 h-4 w-4"
                            />
                            <div>
                              <p className="font-black text-gray-900 leading-tight">{st.nombre_completo}</p>
                              <p className="text-xs text-gray-500 mt-0.5">{st.numero_control} • {st.carrera}</p>
                            </div>
                          </label>
                        ))
                      )}
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-xs text-blue-800 leading-relaxed">
                  Se creará el grupo <strong>{formGroupCode || '---'}</strong> para cada materia seleccionada,
                  con el docente asignado y los alumnos marcados. Esto evita capturar materia por materia manualmente.
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 text-white rounded-lg font-bold text-sm cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                  style={{ backgroundColor: brandColors.guinda }}
                >
                  {loading ? 'Creando grupo...' : 'Crear Grupo y Matricular'}
                </button>
              </form>
            </div>
          </div>
        )}
        </div>
      </div>
    );
  }

  function renderAdminTeacherDetail() {
    if (!selectedTeacher || !teacherDetailData) return null;

    // 1. FILTRAR Y SEPARAR LOS CRITERIOS
    const isOpinion = (text) => {
      const lowerText = (text || '').toLowerCase();
      return lowerText.includes('opinión') || lowerText.includes('opinion');
    };

    const regularCriteria = teacherDetailData.criteria.filter(c => !isOpinion(c.subject));
    const opinionCriteria = teacherDetailData.criteria.filter(c => isOpinion(c.subject));

    // 2. PREPARAR DATOS GRÁFICA 1: DESEMPEÑO GENERAL
    const regularChartData = regularCriteria.map((c, i) => ({
      letter: String.fromCharCode(65 + i), // A, B, C...
      subject: c.subject || `Dimensión ${i + 1}`,
      value: parseFloat(c.A || c.score || 0)
    }));

    // Añadimos Total al Desempeño General
    regularChartData.push({
      letter: 'Total',
      subject: 'Promedio General',
      value: parseFloat(selectedTeacher.score || 0)
    });

    // 3. PREPARAR DATOS GRÁFICA 2: OPINIÓN ESTUDIANTIL
    const opinionChartData = opinionCriteria.map((c, i) => ({
      letter: String.fromCharCode(65 + i), // Reinicia A, B, C... para las opiniones
      subject: c.subject,
      value: parseFloat(c.A || c.score || 0)
    }));

    // Calculamos y añadimos el Total de Opinión (si hay preguntas de opinión)
    if (opinionChartData.length > 0) {
      const avgOpinion = opinionChartData.reduce((acc, curr) => acc + curr.value, 0) / opinionCriteria.length;
      opinionChartData.push({
        letter: 'Total',
        subject: 'Promedio Opinión',
        value: avgOpinion
      });
    }

    // Herramienta para formatear el tooltip al pasar el mouse
    const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        return (
          <div className="bg-white p-3 border border-gray-200 shadow-lg rounded-lg">
            <p className="text-sm font-bold text-gray-900">{payload[0].payload.letter} - {payload[0].payload.subject}</p>
            <p className="text-sm font-black" style={{ color: brandColors.guinda }}>
              Calificación: {payload[0].value.toFixed(2)}
            </p>
          </div>
        );
      }
      return null;
    };

    return (
      <div className="min-h-screen bg-gray-50 pb-12 institutional-page">
        {renderInstitutionalHeader("Detalle de Evaluación Docente")}
        <header className="text-white shadow-md py-4" style={{ backgroundColor: brandColors.guinda }}>
          <div className="max-w-7xl mx-auto px-4 flex justify-between">
            <button onClick={() => { setView('admin_dashboard'); setSelectedTeacher(null); setTeacherDetailData(null); }} className="flex items-center font-bold cursor-pointer">
              <ChevronLeft className="h-5 w-5 mr-1" /> Volver
            </button>
          </div>
        </header>
        <main className="max-w-7xl mx-auto px-4 py-8 space-y-8 animate-fadeIn">
          
          {/* TARJETAS DE INFORMACIÓN SUPERIOR */}
          <div className="bg-white rounded-xl shadow-sm border-t-4 p-6 flex flex-col md:flex-row justify-between items-center" style={{ borderColor: brandColors.guinda }}>
            <div className="flex items-center">
              <div className="h-20 w-20 rounded-full border-2 flex items-center justify-center" style={{ borderColor: brandColors.dorado }}>
                <span className="text-3xl font-black" style={{ color: brandColors.guinda }}>{selectedTeacher.name.substring(0,2)}</span>
              </div>
              <div className="ml-5">
                <h2 className="text-2xl font-black">{selectedTeacher.name}</h2>
                <p className="text-sm font-semibold text-gray-500">{selectedTeacher.department}</p>
              </div>
            </div>
            <div className="flex gap-4 text-center mt-4 md:mt-0">
              <div className="px-5 py-3 border rounded-lg">
                <span className="text-xs font-bold text-gray-400">EVALUACIONES</span>
                <p className="text-xl font-black">{selectedTeacher.evaluationsCount}</p>
              </div>
              <div className="px-5 py-3 border rounded-lg" style={{ borderColor: brandColors.guinda }}>
                <span className="text-xs font-bold" style={{ color: brandColors.guinda }}>PROMEDIO GENERAL</span>
                <p className="text-2xl font-black" style={{ color: brandColors.guinda }}>{selectedTeacher.score ? selectedTeacher.score.toFixed(2) : '0.00'}</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* COLUMNA IZQUIERDA: GRÁFICAS */}
            <div className="space-y-6">
              
              {/* GRÁFICA 1: DESEMPEÑO REGULAR */}
              <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col justify-between">
                <h3 className="text-lg font-bold mb-4 text-center text-gray-700">Desempeño Académico</h3>
                <div className="h-56 w-full mb-6">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={regularChartData} margin={{ top: 20, right: 10, left: -25, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                      <XAxis dataKey="letter" tickLine={false} axisLine={{ stroke: '#E5E7EB' }} tick={{ fill: '#374151', fontSize: 12, fontWeight: 'bold' }} />
                      <YAxis domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} tickLine={false} axisLine={false} tick={{ fill: '#374151', fontSize: 12 }} />
                      <RechartsTooltip content={<CustomTooltip />} cursor={{ fill: '#F3F4F6' }} />
                      <Bar dataKey="value" stroke="#3B82F6" strokeWidth={1}>
                        {regularChartData.map((entry, index) => (
                          <Cell key={`cell-reg-${index}`} fill={entry.letter === 'Total' ? '#15803D' : '#FF4500'} />
                        ))}
                        
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
                {/* LEYENDA GRÁFICA 1 */}
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-bold text-gray-500 mb-3 uppercase tracking-wider">Aspectos Evaluados:</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                    {regularChartData.filter(item => item.letter !== 'Total').map((item) => (
                      <div key={item.letter} className="flex items-start text-sm">
                        <span className="font-black text-gray-900 w-6 shrink-0">{item.letter}.</span>
                        <span className="text-gray-700 leading-tight">{item.subject}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* GRÁFICA 2: OPINIÓN (Se oculta si no hay preguntas de opinión) */}
              {opinionChartData.length > 0 && (
                <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col justify-between">
                  <h3 className="text-lg font-bold mb-4 text-center text-gray-700">Opinión y Percepción Estudiantil</h3>
                  <div className="h-56 w-full mb-6">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={opinionChartData} margin={{ top: 20, right: 10, left: -25, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                        <XAxis dataKey="letter" tickLine={false} axisLine={{ stroke: '#E5E7EB' }} tick={{ fill: '#374151', fontSize: 12, fontWeight: 'bold' }} />
                        <YAxis domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} tickLine={false} axisLine={false} tick={{ fill: '#374151', fontSize: 12 }} />
                        <RechartsTooltip content={<CustomTooltip />} cursor={{ fill: '#F3F4F6' }} />
                        <Bar dataKey="value" stroke="#8B5CF6" strokeWidth={1}>
                          {opinionChartData.map((entry, index) => (
                            <Cell key={`cell-op-${index}`} fill={entry.letter === 'Total' ? '#047857' : '#F59E0B'} /> 
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  {/* LEYENDA GRÁFICA 2 */}
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                    <p className="text-xs font-bold text-gray-500 mb-3 uppercase tracking-wider">Aspectos de Opinión:</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                      {opinionChartData.filter(item => item.letter !== 'Total').map((item) => (
                        <div key={item.letter} className="flex items-start text-sm">
                          <span className="font-black text-gray-900 w-6 shrink-0">{item.letter}.</span>
                          <span className="text-gray-700 leading-tight">{item.subject}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* COLUMNA DERECHA: RESULTADOS POR ASIGNATURA */}
            <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col">
              <div className="flex-1">
                <h3 className="text-lg font-bold mb-4">Resultados Detallados por Asignatura</h3>
                <div className="space-y-4">
                  {teacherDetailData.details.map((subj, index) => (
                    <div key={index} className="border p-4 rounded-lg">
                      <div className="flex justify-between mb-2">
                        <h4 className="font-bold text-sm">{subj.subject}</h4>
                        <span className="font-black text-sm">{subj.score ? subj.score.toFixed(2) : '0.00'} / 5.0</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="h-2 rounded-full" 
                          style={{ width: `${((subj.score || 0) / 5) * 100}%`, backgroundColor: subj.score >= 4.5 ? '#10B981' : subj.score >= 3.0 ? '#F59E0B' : '#EF4444' }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <button onClick={() => {
                  window.open(
                    `${API_URL}/admin/docente/${selectedTeacher.id_docente}/acta`,
                    '_blank'
                  );
                }}
                className="w-full py-3 mt-6 text-white font-bold rounded-lg cursor-pointer transition-colors mt-auto"
                style={{ backgroundColor: brandColors.guinda }}
              >
                <FileText className="inline mr-2 h-5 w-5" />
                Descargar Acta de Evaluación
              </button>
            </div>

          </div>
        </main>
      </div>
    );
  }
}